/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import ReactResizeDetector from 'react-resize-detector';
import { uniqueId } from 'lodash';
import { Line as ProgressBar } from 'rc-progress';
import _ from 'lodash';
import injectReducer from 'utils/injectReducer';
import { makeSelectStepSupportingDocuments, makeSelectStepSupportingDocumentsErrors } from './selectors';
import reducer from './reducer';

import { Button } from '../components/Button';
import WizardNavigationButtons from '../components/WizardNavigationButtons';
import Section from '../components/Section';
import ControlContainer from '../components/ControlContainer';
import OptionsContainer from '../components/OptionsContainer';
import FlexBox from '../../../components/FlexBox';
import {
  removeFile,
  resetFormData,
  uploadFile,
  uploadRequireDocFile,
  runRequiredDocValidation,
  cancelRequiredDocValidation,
  nextSlide,
  handleFormDataChange,
} from './actions';
import { REQUIRED_DOCUMENT_DISPLAY_CODE } from 'containers/FastCover/constants';
import { SCTI_VISITING_NEW_ZEALAND_POLICY_TYPES } from 'containers/FastCover/constants/policyTypes';
import { Table, TH, TR, TD } from '../../../components/Table';
import Icon from '../../../components/Icon';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import messages from './messages';
import { makeSelectJSONVersion, makeSelectInitClaimTypeList, makeSelectShowRequiredDocument, makeSelectShowZurichUHC, makeSelectPolicyTypeCode, makeSelectFormHasChanges } from '../../App/selectors';
import { AttachSupportingDocuments } from './components/AttachSupportingDocuments';
import { UploadSupportingDocuments } from './components/UploadSupportingDocuments';
import { ShowPBEValidationMesssage } from './components/ShowPBEValidationMesssage';
import { ShowPBValidationMesssage } from './components/ShowPBValidationMesssage';
import { ShowSupportingDocuments } from './components/ShowSupportingDocuments';
import { saveFormData } from '../actions';
import { setFormHasChanges } from '../../App/actions';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import AsyncButton from '../../../components/AsyncButton';
import ModalError from './components/ModalError';
import { makeSelectStepWhatHappened } from '../StepWhatHappened/selectors';
import { makeSelectStepTripCancellationAndTripInterruption } from '../StepTripCancellationAndTripInterruption/selectors';
import { makeSelectStepOther } from '../StepOther/selectors';
import { makeSelectTripCancellationCFStep } from '../Trawick.CFTripCan.TripCancellationStep/selectors';
import { makeSelectMedicalExpenseCFStep } from '../Trawick.CFTripCan.MedicalExpense/selectors';
import { makeSelectStepTravelDelay } from '../StepTravelDelay/selectors';
import { makeSelectTripDelayStep } from '../Trawick.NationWide.TripDelayStep/selectors';
import { makeSelectMedicalAndEvacuationSCTIStep } from '../Trawick.SCTI.MedicalAndEvacuation/selectors';
import { makeSelectBaggageAndPersonalItemsSCTIStep } from '../Trawick.SCTI.BaggageAndPersonalItems/selectors';
import { makeSelectChangesToYourJourneySCTIStep } from '../Trawick.SCTI.ChangesToYourJourney/selectors';
import { makeSelectChangesToYourJourneyStep } from '../Trawick.ChangesToYourJourney/selectors';
import { makeSelectStepBaggageAndPersonalItems } from '../StepBaggageAndPersonalItems/selectors';
import { makeSelectStepBaggageAndPersonalItemsStarr } from '../Trawick.Starr.StepBaggageAndPersonalItems/selectors';
import { makeSelectStepOtherStarr } from '../Trawick.Starr.StepOther/selectors';
import { makeSelectCollisionDamageStarrStep } from '../Trawick.Starr.StepCollisionDamage/selectors';
import { makeSelectCollisionDamageStep } from '../Trawick.NationWide.CollisionDamageStep/selectors';
import { makeSelectCashBankCardsTravelDocumentsAndPassportsStep } from '../Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/selectors';
import StepCancellationAdditionalShared from '../StepCancellationAdditional/components/StepCancellationAdditionalShared';
import StepPersonalItemsShared from '../StepPersonalItems/components/StepPersonalItemsShared';
import StepOverseasMedicalShared from '../StepOverseasMedical/components/StepOverseasMedicalShared';
import StepRentalVehicleShared from '../StepRentalVehicle/StepRentalVehicleShared';
import StepOtherShared from '../StepOther/components/StepOtherShared';
import StepOtherSharedForAD from '../StepOther/components/StepOtherSharedForAD';
import StepOtherSharedForBurialExpenses from '../StepOther/components/StepOtherSharedForBurialExpenses';
import StepOtherSharedForRepatriationExpenses from '../StepOther/components/StepOtherSharedForRepatriationExpenses';
import StepTripCancellationAndTripInterruptionSharedTravelDelay from '../StepTripCancellationAndTripInterruption/components/StepTripCancellationAndTripInterruptionSharedTravelDelay';
import StepBaggageAndPersonalItemsShared from '../StepBaggageAndPersonalItems/components/StepBaggageAndPersonalItemsShared';
import StepMedicalExpensesShared from '../StepMedicalExpenses/components/StepMedicalExpensesShared';
import MedicalExpenseStepShared from '../Trawick.NationWide.MedicalExpenseStep/components/MedicalExpenseStepShared';
import TripCancellationStepShared from '../Trawick.NationWide.TripCancellationStep/components/TripCancellationStepShared';
import TripInterruptionStepShared from '../Trawick.NationWide.TripInterruptionStep/components/TripInterruptionStepShared';
import TripDelayStepShared from '../Trawick.NationWide.TripDelayStep/components/TripDelayStepShared';
import MissedConnectionStepShared from '../Trawick.NationWide.MissedConnectionStep/components/MissedConnectionStepShared';
import PropertyDamageStepShared from '../Trawick.NationWide.PropertyDamageStep/components/PropertyDamageStepShared';
import CollisionDamageStepShared from '../Trawick.NationWide.CollisionDamageStep/components/CollisionDamageStepShared';
import PetMedicalStepShared from '../Trawick.NationWide.PetMedicalStep/components/PetMedicalStepShared';
import AccidentalDeathAndDismembermentStepShared from '../Trawick.NationWide.AccidentalDeathAndDismembermentStep/components/AccidentalDeathAndDismembermentStepShared';
import ItineraryChangeStepShared from '../Trawick.CFTripCan.ItineraryChange/components/ItineraryChangeStepShared';
import MedicalExpenseCFStepShared from '../Trawick.CFTripCan.MedicalExpense/components/MedicalExpenseCFStepShared';
import MedicalExpenseZurichStepShared from '../Trawick.Zurich.MedicalExpense/components/MedicalExpenseZurichStepShared';
import BaggagePersonalEffectsShared from '../Trawick.CFTripCan.BaggagePersonalEffects/components/BaggagePersonalEffectsShared';
import TripCancellationCFStepShared from '../Trawick.CFTripCan.TripCancellationStep/components/TripCancellationCFStepShared';
import TripDelayCFStepShared from '../Trawick.CFTripCan.TripCancellationStep/components/TripDelayCFStepShared';
import TripInterruptionCFStepShared from '../Trawick.CFTripCan.TripCancellationStep/components/TripInterruptionCFStepShared';
import JobLossHardshipStepShared from '../Trawick.DuesProtect.JobLossHardshipStep/components/JobLossHardshipStepShared';
import DisasterAssistanceHardshipStepShared from '../Trawick.DuesProtect.DisasterAssistanceHardshipStep/components/DisasterAssistanceHardshipStepShared';
import CriticalIllnessStepShared from '../Trawick.DuesProtect.MedicalHardshipStep/components/CriticalIllnessStepShared';
import DeathStepShared from '../Trawick.DuesProtect.MedicalHardshipStep/components/DeathStepShared';
import DisabilityStepShared from '../Trawick.DuesProtect.MedicalHardshipStep/components/DisabilityStepShared';
import DismembermentStepShared from '../Trawick.DuesProtect.MedicalHardshipStep/components/DismembermentStepShared';
import LeaveOfAbsenceStepShared from '../Trawick.DuesProtect.MedicalHardshipStep/components/LeaveOfAbsenceStepShared';
import StepMedicalAndEvacuationShared from '../Trawick.SCTI.MedicalAndEvacuation/components/StepMedicalAndEvacuationShared';
import StepChangesToYourJourneyShared from '../Trawick.SCTI.ChangesToYourJourney/components/StepChangesToYourJourneyShared';
import StepBaggageAndPersonalItemsSCTIShared from '../Trawick.SCTI.BaggageAndPersonalItems/components/StepBaggageAndPersonalItemsShared';
import StepPersonalAccidentSCTIShared from '../Trawick.SCTI.PersonalAccident/components/StepPersonalAccidentShared';
import StepRentalVehicleExcessSCTIShared from '../Trawick.SCTI.RentalVehicleExcess/components/StepRentalVehicleExcessShared';
import StepCashBankCardsTravelDocumentsAndPassportsShared from '../Trawick.SCTI.CashBankCardsTravelDocumentsAndPassports/components/StepCashBankCardsTravelDocumentsAndPassportsShared';
import {
  stepCancellationAdditionalExpenseLookup,
  stepPersonalItemsExpenseLookup,
  stepOverseasMedicalExpenseLookup,
  stepRentalVehicleExpenseLookup,
  stepOtherExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepBaggageAndPersonalItemsExpenseLookup,
  stepMedicalExpensesExpenseLookup,
  stepPetMedicalExpenseLookup,
  stepPropertyDamageExpenseLookup,
  stepMedicalExpenseLookup,
  stepTripCancellationLookup,
  stepTripInterruptionLookup,
  stepTripDelayLookup,
  stepMissedConnectionLookup,
  stepAccidentalDeathAndDismembermentLookup,
  stepMedicalExpenseCFLookup,
  stepTripCancellationCFLookup,
  baggagePersonalEffectsLookup,
  itineraryChangeLookup,
  medicalHardshipLookup,
  jobLossHardshipLookup,
  disasterAssistanceHardshipLookup,
  stepTravelDelayLookup,
  stepMedicalAndEvacuationLookup,
  stepChangesToYourJourneyLookup,
  stepBaggageAndPersonalItemsSCTILookup,
  stepCashBankCardsTravelDocumentsAndPassportsLookup,
  stepPersonalAccidentSCTILookup,
  stepRentalVehicleExcessSCTILookup,
  stepMedicalExpensesTugoLookup,
  stepOtherTugoLookup,
} from '../dataMapper/claimCodeMapper';
import stepChangesToYourJourneyDataMapper from '../dataMapper/stepChangesToYourJourneyDataMapper';
import stepMedicalExpenseCFDataMapper from '../dataMapper/stepMedicalExpenseCFDataMapper';
import stepBaggageAndPersonalItemsStarrDataMapper from '../dataMapper/stepBaggageAndPersonalItemsStarrDataMapper';
import stepBaggageAndPersonalItemsDataMapper from '../dataMapper/stepBaggageAndPersonalItemsDataMapper';
import stepCollisionDamageDataMapper from '../dataMapper/stepCollisionDamageDataMapper';
import stepCollisionDamageStarrDataMapper from '../dataMapper/stepCollisionDamageStarrDataMapper';
import stepOtherDataStarrMapper from '../dataMapper/stepOtherDataStarrMapper';
import stepBaseVictorsMedicalTugoDataMapper from '../dataMapper/stepBaseVictorsMedicalTugoDataMapper';
import stepOtherTugoDataMapper from '../dataMapper/stepOtherDataTugoMapper';
import stepMedicalAndEvacuationSCTIDataMapper from '../dataMapper/stepMedicalAndEvacuationSCTIDataMapper';
import stepChangesToYourJourneySCTIDataMapper from '../dataMapper/stepChangesToYourJourneySCTIDataMapper';
import stepBaggageAndPersonalItemsSCTIDataMapper from '../dataMapper/stepBaggageAndPersonalItemsSCTIDataMapper';
import P from '../../../components/P';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation';
import { makeSelectCurrentStep } from '../../Wizard/selectors';

import { makeSelectMedicalExpensesTugoStep } from '../Tugo.MedicalExpenses/selectors';
import { makeSelectStepOtherTugo } from '../Tugo.StepOther/selectors';
// import { makeSelectMedicalExpenseCFStep } from '../Trawick.CFTripCan.MedicalExpense/selectors';
import { makeSelectBaseVictorsMedicalTugo } from '../Tugo.BaseVictorsMedical/selectors';
import { appConfig } from '../../../configureApp';
// import stepMedicalExpenseCFDataMapper from '../dataMapper/stepMedicalExpenseCFDataMapper';
// import stepBaggageAndPersonalItemsStarrDataMapper from '../dataMapper/stepBaggageAndPersonalItemsStarrDataMapper';
import { map as mapToClaimData } from '../dataMapper/apiContractMapper';

export class StepSupportingDocuments extends React.Component {
  constructor(props) {
    super(props);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
    this.allowValidateDocuments = {};

    this.state = {
      invalidFileName: false,
      isLongFileName: false,
      listDocuments: [],
    };

    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.checkFileNameLength = this.checkFileNameLength.bind(this);
    this.onAttachDocumentChange = this.onAttachDocumentChange.bind(this);
    this.onAttachRequiredDocumentChange = this.onAttachRequiredDocumentChange.bind(this);
    this.onRunValidation = this.onRunValidation.bind(this);
    this.onCancelValidation = this.onCancelValidation.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName, isSummary } = this.props;


    // Prefer using the frozen snapshot (captured at submit time) when available,
    // so that mandatory flags and document definitions stay the same for submitted claims.
    let listDocuments;
    const snapshot = nextProps.form && nextProps.form.submittedDocumentsSnapshot;
    if (snapshot && snapshot.documents && Array.isArray(snapshot.documents)) {
      listDocuments = snapshot.documents;
    } else {
      listDocuments = this.mapDocumentItems();
    }

    if (listDocuments.length === 0 && !isSummary) {
      this.props.onFormDataChange('form.showWarningMissingRequiredDocument', false);
      this.props.onFormDataChange('form.warningMissingRequiredDocument', '');
    }

    this.setState({ listDocuments });

    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }
    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  componentWillUpdate() {
    if (this.props.adjust) {
      // this is a workaround to ensure we refresh the UI
      // to render the list of attachments.
      this.props.adjust();
    }
  }
  componentDidUpdate(prevProps) {
    // Check if attachDocuments has changed after upload
    if (prevProps.form.attachDocuments !== this.props.form.attachDocuments) {
      this.validateRequiredDocuments();

      // Auto-trigger validation for newly uploaded files
      this.autoTriggerValidation(this.props.form.attachDocuments, prevProps.form.attachDocuments);
    }
  }

  onResize() {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  }

  autoTriggerValidation = (currentAttachments, prevAttachments) => {
    // Find newly uploaded files
    const newAttachments = currentAttachments.filter(currentAttachment =>
      !prevAttachments.some(prevAttachment => prevAttachment.id === currentAttachment.id)
    );

    // Logic: If a file is uploaded against the same row (requiredDocumentId),
    // CANCEL the current validation and restart it with the new data.
    // If files are for different rows, validations run in parallel without cancelling each other.
    var requiredDocumentIds = newAttachments.map(att => att.requiredDocumentId);
    requiredDocumentIds = [...new Set(requiredDocumentIds)]; // Unique IDs

    const { listDocuments } = this.state;
    requiredDocumentIds.forEach(requiredDocumentId => {
      // Find the document details to check if validation is required
      const document = this.findDocumentById(requiredDocumentId, listDocuments);
      if (document && document.runDocumentValidation === true) {
        // Cancel any existing validation for this requiredDocumentId before starting new one
        this.onCancelValidation(requiredDocumentId, document.claimTypeId);
        // Start new validation
        this.onRunValidation([], requiredDocumentId, document.claimTypeId);
      }
    });
  };

  findDocumentById = (requiredDocumentId, listDocuments) => {
    for (const item of listDocuments) {
      const document = (item.requiredDocuments || []).find(doc =>
        doc.claimRequiredDocumentId == requiredDocumentId,
      );
      if (document && this.allowValidateDocuments[item.claimTypeId] == true) {
        return {
          ...document,
          claimTypeId: item.claimTypeId
        };
      }
    }
    return null;
  };

  onAttachDocumentChange(benefitCode, files) {
    const { onFileUpload } = this.props;
    const file = files ? files[0] : {};
    if (this.checkFileNameLength(file)) {
      this.setState({ isLongFileName: true }, () => {
        this.showModal();
      });
    } else if (this.checkFileExist(file)) {
      this.setState({ isLongFileName: false }, () => {
        this.showModal();
      });
    } else {
      onFileUpload(files, benefitCode);
      this.props.setFormHasChanges(true);
    }
  }

  onAttachRequiredDocumentChange(benefitCode, requiredDocumentId, claimTypeId, claimExpenseGuid, displayCode, files) {
    const { onRequireDocFileUpload } = this.props;
    const file = files ? files[0] : {};
    const uploadRequest = {
      benefitCode,
      requiredDocumentId,
      claimTypeId,
      claimExpenseGuid,
      displayCode,
    };
    if (this.checkFileNameLength(file)) {
      this.setState({ isLongFileName: true }, () => {
        this.showModal();
      });
    } else if (this.checkFileExist(file)) {
      this.setState({ isLongFileName: false }, () => {
        this.showModal();
      });
    } else {
      onRequireDocFileUpload(files, uploadRequest);
      this.props.setFormHasChanges(true);
    }
  }

  handleFileRemove = (file) => {
    this.props.onFileRemove(file);
    this.props.setFormHasChanges(true);
  };

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    this.props.setFormHasChanges(true);
  };

  checkFormError() {
    const {
      attachDocuments,
      warningMissingRequiredDocument,
      validationMessages,
    } = this.props.form;
    const { listDocuments } = this.state;
    const { jsonVersion } = this.props;
    const versionFNOLRefactoring = jsonVersion > 11;
    const versionShowInvalidRequiredDoc = jsonVersion > 15;
    const requiredDocumentsList = listDocuments
      .map((item) => {
        return (item.requiredDocuments || []).filter((doc) => {
          if (doc.mandatory === true) {
            doc.claimTypeId = item.claimTypeId;
            return true;
          }
          return false;
        });
      })
      .flat();

    // Filter missing documents
    const missingDocuments = requiredDocumentsList.filter((doc) =>
      !attachDocuments.some((up) => up.requiredDocumentId === doc.claimRequiredDocumentId)
    );
    const to = requiredDocumentsList.filter((doc) =>
      !validationMessages.some((up) => up.requiredDocumentId === doc.claimRequiredDocumentId)
    );

    const validationRequiredDocs = requiredDocumentsList.filter(doc => doc.runDocumentValidation === true && this.allowValidateDocuments[doc.claimTypeId] == true);

    // Check if length mismatch or if any validation message has success = false or null
    const lengthMismatch = validationMessages.length !== validationRequiredDocs.length;
    const hasFailedOrPendingValidation = validationMessages.some(msg => msg.Success !== true);
    const isValidRequiredDocument = !lengthMismatch && !hasFailedOrPendingValidation;

    const isValidetionrRquiredDocument = missingDocuments.length === 0;
    if (!versionFNOLRefactoring || (isValidetionrRquiredDocument && isValidRequiredDocument && to)) {
      this.props.onFormDataChange('form.showWarningMissingRequiredDocument', false);
      this.props.onFormDataChange('form.warningMissingRequiredDocument', '');
      this.props.onFormDataChange('form.showWarningInvalidRequiredDocument', false);
    } else {
      this.props.onFormDataChange('form.showWarningMissingRequiredDocument', !isValidetionrRquiredDocument);
      this.props.onFormDataChange('form.showWarningInvalidRequiredDocument', versionShowInvalidRequiredDoc ? !isValidRequiredDocument : false);
    }

    const valid = this.validatorGroup.checkValidation() && (warningMissingRequiredDocument === '' || !versionFNOLRefactoring);
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.handleFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  validateRequiredDocuments = () => {
    const {
      attachDocuments,
      warningMissingRequiredDocument,
      validationMessages,
    } = this.props.form;
    const { listDocuments } = this.state;
    const { jsonVersion, submitted } = this.props;
    const versionFNOLRefactoring = jsonVersion > 11;

    if (submitted) {
      this.props.next();
      return;
    }

    const versionShowInvalidRequiredDoc = jsonVersion > 15;
    const requiredDocumentsList = listDocuments
      .map((item) => {
        return (item.requiredDocuments || []).filter((doc) => {
          if (doc.mandatory === true) {
            doc.claimTypeId = item.claimTypeId;
            return true;
          }
          return false;
        });
      })
      .flat();
    // Filter missing documents
    const missingDocuments = requiredDocumentsList.filter((doc) =>
      !attachDocuments.some((up) => up.requiredDocumentId === doc.claimRequiredDocumentId)
    );

    const validationRequiredDocs = requiredDocumentsList.filter(doc => doc.runDocumentValidation === true && this.allowValidateDocuments[doc.claimTypeId] == true);

    // Check if length mismatch or if any validation message has success = false or null
    const lengthMismatch = validationMessages.length !== validationRequiredDocs.length;
    const hasFailedOrPendingValidation = validationMessages.some(msg => msg.Success !== true);
    let isValidRequiredDocument = !lengthMismatch && !hasFailedOrPendingValidation;

    let isValidetionrRquiredDocument = missingDocuments.length === 0;
    if (!versionFNOLRefactoring || (isValidetionrRquiredDocument && isValidRequiredDocument)) {
      this.props.onFormDataChange('form.showWarningMissingRequiredDocument', false);
      this.props.onFormDataChange('form.warningMissingRequiredDocument', '');
      this.props.onFormDataChange('form.showWarningInvalidRequiredDocument', false);
    } else {
      this.props.onFormDataChange('form.showWarningMissingRequiredDocument', !isValidetionrRquiredDocument);
      this.props.onFormDataChange('form.showWarningInvalidRequiredDocument', versionShowInvalidRequiredDoc ? !isValidRequiredDocument : false);
    }

    if (warningMissingRequiredDocument === 'true') {
      isValidetionrRquiredDocument = true;
      isValidRequiredDocument = true;
    }
    return isValidetionrRquiredDocument && isValidRequiredDocument;
  };

  captureDocumentsSnapshot = () => {
    const { listDocuments } = this.state;
    const { attachDocuments } = this.props.form;

    // Capture full document structure including mandatory flags and all metadata
    const documentsSnapshot = listDocuments.map((item) => ({
      claimTypeId: item.claimTypeId,
      claimCode: item.claimCode,
      description: item.description,
      requiredDocuments: (item.requiredDocuments || []).map((doc) => ({
        claimRequiredDocumentId: doc.claimRequiredDocumentId,
        requiredDocumentDescription: doc.requiredDocumentDescription,
        mandatory: doc.mandatory,
        toolTipDescription: doc.toolTipDescription,
        runDocumentValidation: doc.runDocumentValidation,
        Success: doc.Success,
        Message: doc.Message,
      })),
    }));

    // Capture current attachments
    const attachmentsSnapshot = (attachDocuments || []).map((attachment) => ({
      id: attachment.id,
      name: attachment.name,
      benefitCode: attachment.benefitCode,
      requiredDocumentId: attachment.requiredDocumentId,
      groupName: attachment.groupName,
      success: attachment.success,
      message: attachment.message,
    }));

    // Store the complete snapshot
    const snapshot = {
      documents: documentsSnapshot,
      attachments: attachmentsSnapshot,
      capturedAt: new Date().toISOString(),
    };

    this.props.onFormDataChange('form.submittedDocumentsSnapshot', snapshot);
  };

  handleNext = () => {
    // Capture snapshot before moving to next step (which is declaration step)
    this.captureDocumentsSnapshot();

    const {
      warningMissingRequiredDocument,
    } = this.props.form;
    const { submitted, jsonVersion } = this.props;
    const versionFNOLRefactoring = jsonVersion > 11;

    if (submitted) {
      this.props.next();
      return;
    }

    const isRequiredDocumentValid = this.validateRequiredDocuments();

    const valid = this.validatorGroup.checkValidation() && (warningMissingRequiredDocument === '' || !versionFNOLRefactoring);
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    if (isRequiredDocumentValid || !versionFNOLRefactoring) {
      this.handleFormDataSave();
      this.props.next();
    }
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
    this.props.setFormHasChanges(false);
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  showModal() {
    this.setState({ invalidFileName: true });
  }

  hideModal() {
    this.setState({ invalidFileName: false });
  }

  checkFileNameLength(file) {
    if (file.name && file.name.length > 50) {
      return true;
    }
    return false;
  }

  checkFileExist = (file) => {
    if (this.props.form.attachDocuments.length) {
      return this.props.form.attachDocuments.filter((f) => f.name === file.name).length > 0;
    }
    return false;
  };

  mapQuestionItem(claimType, description) {
    return {
      claimCode: claimType.claimCode,
      description,
      claimTypeId: claimType.claimTypeId,
      requiredDocuments: claimType.requiredDocuments,
    };
  }

  onRunValidation(attachmentIds, requiredDocumentId, claimTypeId) {
    const { onRunRequiredDocValidation } = this.props;
    onRunRequiredDocValidation(attachmentIds, requiredDocumentId, claimTypeId);
  }

  mapDocumentItems() {
    const { claimTypesInit, policyTypeCode } = this.props;
    const { selectedBenefits } = this.props.stepWhatHappenedData;
    // Trawick Benefits
    const isInternationalStudent = policyTypeCode === 'INT-ST-NZ';
    const policyTypeVisitingNZ = ['VISIT-NZ', 'VISIT-NZ-PI'];
    const isVisitingNewZealand = policyTypeVisitingNZ.includes(policyTypeCode);
    const policyTypeWorkingOverseas = ['WORK-AU', 'WORK-NZ'];
    const isWorkingOverseas = policyTypeWorkingOverseas.includes(policyTypeCode);
    const isShowSubBenefits = isInternationalStudent || isVisitingNewZealand || isWorkingOverseas;
    const { travelInterruption, tripCancellation, tripCancellationForAnyReason } = this.props.stepTripCancellationAndTripInterruptionData;
    const { areYouClaimingForAccidentalDeathAndDismemberment, areYouClaimingForRepatriationExpenses, areYouClaimingForBurialExpenses, whatExpensesAreYouClaimingFor, whatAreYourExpensesRelatedTo } = this.props.stepOtherData;
    const { didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised, wasTheDeathCausedByAnInjury, whatExpensesAreYouClaimingFor: whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI, whatAreYourExpensesRelatedTo: MAEWhatAreYourExpensesRelatedTo } = this.props.stepMedicalAndEvacuationSCTIData;
    const { whatHappenedToYourBaggageAndPersonalItems, whatItemsAreYouClaimingFor } = this.props.stepBaggageAndPersonalItemsSCTIData;
    const { whatItemsAreYouClaimingFor: passportItemsClaiming } = this.props.stepCashBankCardsTravelDocumentsAndPassportsData;
    const { haveYouCanceledOrChangedYourJourneyBeforeLeaving, haveYouChangedYourJourneyAfterLeaving, wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition,
      wereYouChargedACancellationFeeByTheTravelAgent, wereYouDelayedWhileTravelingToASpecialEvent, wereYouDelayedWhileTravelingToASpecialEventAL,
      didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption, wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL } = this.props.stepChangesToYourJourneySCTIData;
    // Trawick UI
    const selectedBenefitsChangesToYourJourney = stepChangesToYourJourneyDataMapper.mapToClaimExpensesLevel(this.props.stepChangesToYourJourneyData, claimTypesInit, selectedBenefits);
    const selectedBenefitsMedicalExpense = stepMedicalExpenseCFDataMapper.mapToClaimExpensesLevel(this.props.stepMedicalExpenseCFData, claimTypesInit, selectedBenefits);
    const selectedBenefitsBaggageAndPersonalItems = stepBaggageAndPersonalItemsDataMapper.mapToClaimExpensesLevel(this.props.stepBaggageAndPersonalItemsData, claimTypesInit, selectedBenefits);
    const selectedBenefitsBaggageAndPersonalItemsStarr = stepBaggageAndPersonalItemsStarrDataMapper.mapToClaimExpensesLevel(this.props.stepBaggageAndPersonalItemsStarrData, claimTypesInit, selectedBenefits);
    const selectedBenefitsOtherStarr = stepOtherDataStarrMapper.mapToClaimExpensesLevel(this.props.stepOtherStarrData, claimTypesInit, selectedBenefits);
    const selectedBenefitsCollisionDamage = stepCollisionDamageDataMapper.mapToClaimExpensesLevel(this.props.stepCollisionDamageData, claimTypesInit, selectedBenefits);
    const selectedBenefitsCollisionDamageStarr = stepCollisionDamageStarrDataMapper.mapToClaimExpensesLevel(this.props.stepCollisionDamageStarrData, claimTypesInit, selectedBenefits);

    const expensesPersonalLiabilitySelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    const whatAreYourExpensesRelatedToSelected = !!whatAreYourExpensesRelatedTo && typeof whatAreYourExpensesRelatedTo.toJS === 'function'
      ? whatAreYourExpensesRelatedTo.toJS()
      : whatAreYourExpensesRelatedTo || [];
    const isPersonalLiabilitySelected = expensesPersonalLiabilitySelected.includes('Personal Liability');
    const isPersonalAccidentSelected = expensesPersonalLiabilitySelected.includes('Personal Accident');
    const isLossOfIncomeCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Loss of Income');
    const isTotalPermanentDisablementCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Total permanent disablement');
    const isLossOfLifeCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Loss of Life');

    // Base list of benefits derived from selected benefits / claim types
    const list = [...(!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || [])]
      .filter((x) => x.description !== 'Other'
        && x.description !== 'Trip Cancellation & Trip Interruption'
        && x.description !== 'Medical and evacuation'
        && x.description !== 'Baggage and personal items' // SCTI
        && x.description !== 'Baggage and Personal Items' // Trawick
        && x.description !== 'Changes to your journey'
        && x.description !== 'Medical Expenses'
        && x.description !== 'Cash, bank cards, travel documents and passports'
        && x.description !== 'Collision Damage'
        && x.description !== 'Medical Expenses - Visitors to Canada'
        && x.description !== 'Medical Expense');

    // Collision Damage
    if (selectedBenefitsCollisionDamage.length > 0) {
      list.push(...selectedBenefitsCollisionDamage);
    }

    // Collision Damage Starr
    if (selectedBenefitsCollisionDamageStarr.length > 0) {
      list.push(...selectedBenefitsCollisionDamageStarr);
    }

    // Baggage and personal items Trawick
    if (selectedBenefitsBaggageAndPersonalItems.length > 0) {
      list.push(...selectedBenefitsBaggageAndPersonalItems);
    }

    // Other Documents
    if ((areYouClaimingForRepatriationExpenses === 'true' || areYouClaimingForAccidentalDeathAndDismemberment === 'true' || areYouClaimingForBurialExpenses === 'true'
      || isPersonalLiabilitySelected || isPersonalAccidentSelected || isLossOfIncomeCodeSelected || isLossOfLifeCodeSelected || isTotalPermanentDisablementCodeSelected) && claimTypesInit !== undefined) {
      const code1 = stepOtherExpenseLookup.areYouClaimingForRepatriationExpenses.claimCode;
      const code2 = stepOtherExpenseLookup.areYouClaimingForAccidentalDeathAndDismemberment.claimCode;
      const code3 = stepOtherExpenseLookup.areYouClaimingForBurialExpenses.claimCode;
      const code4 = stepOtherExpenseLookup.personalLiability.claimCode;
      const code5 = stepOtherExpenseLookup.personalAccident.claimCode;
      const lossOfIncomeCode = stepOtherExpenseLookup.lossOfIncome.claimCode;
      const lossOfLifeCode = stepOtherExpenseLookup.lossOfLife.claimCode;
      const totalPermanentDisablementCode = stepOtherExpenseLookup.totalPermanentDisablement.claimCode;
      claimTypesInit.forEach(
        (item) => {
          if (item.claimCode === code1 && areYouClaimingForRepatriationExpenses === 'true') {
            const benefit = this.mapQuestionItem(item, 'Repatriation Expenses');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code2 && areYouClaimingForAccidentalDeathAndDismemberment === 'true') {
            const benefit = this.mapQuestionItem(item, 'Accidental Death & Dismemberment');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code3 && areYouClaimingForBurialExpenses === 'true') {
            const benefit = this.mapQuestionItem(item, 'Burial Expenses');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code4 && isPersonalLiabilitySelected) {
            const benefit = this.mapQuestionItem(item, 'Personal Liability');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code5 && isPersonalAccidentSelected) {
            const benefit = this.mapQuestionItem(item, 'Personal Accident');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === lossOfIncomeCode && isLossOfIncomeCodeSelected) {
            const benefit = this.mapQuestionItem(item, 'Loss of income');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === lossOfLifeCode && isLossOfLifeCodeSelected) {
            const benefit = this.mapQuestionItem(item, 'Loss of Life');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === totalPermanentDisablementCode && isTotalPermanentDisablementCodeSelected) {
            const benefit = this.mapQuestionItem(item, 'Total permanent disablement');
            if (!!benefit) {
              list.push(benefit);
            }
          }
        }
      );
    }

    // Trip Interruption
    if ((tripCancellation === 'true' || tripCancellationForAnyReason === 'true' || travelInterruption === 'true') && claimTypesInit !== undefined) {
      const code1 = stepTripCancellationAndTripInterruptionExpenseLookup.tripCancellation.claimCode;
      const code2 = stepTripCancellationAndTripInterruptionExpenseLookup.tripCancellationForAnyReason.claimCode;
      const code3 = stepTripCancellationAndTripInterruptionExpenseLookup.travelInterruption.claimCode;
      claimTypesInit.forEach(
        (item) => {
          if (item.claimCode === code1 && tripCancellation === 'true') {
            const benefit = this.mapQuestionItem(item, 'Trip Cancellation');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code2 && tripCancellationForAnyReason === 'true') {
            const benefit = this.mapQuestionItem(item, 'Trip Cancellation For Any Reason');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code3 && travelInterruption === 'true') {
            const benefit = this.mapQuestionItem(item, 'Trip Interruption');
            if (!!benefit) {
              list.push(benefit);
            }
          }
        }
      );
    }

    // Changes To Your Journey Trawick
    if (selectedBenefitsChangesToYourJourney.length > 0) {
      list.push(...selectedBenefitsChangesToYourJourney);
    }

    // Medical Expense Trawick
    if (selectedBenefitsMedicalExpense.length > 0) {
      list.push(...selectedBenefitsMedicalExpense);
    }

    // Baggage and personal items Starr
    if (selectedBenefitsBaggageAndPersonalItemsStarr.length > 0) {
      list.push(...selectedBenefitsBaggageAndPersonalItemsStarr);
    }

    // Other Documents Starr
    if (selectedBenefitsOtherStarr.length > 0) {
      list.push(...selectedBenefitsOtherStarr);
    }

    // Medical and Evacuation SCTI
    const medicalAndEvacuationSCTISelected = !!whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI && typeof whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI.toJS === 'function'
      ? whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI.toJS()
      : whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI || [];

    const MAEWhatAreYourExpensesRelatedToSelected = !!MAEWhatAreYourExpensesRelatedTo && typeof MAEWhatAreYourExpensesRelatedTo.toJS === 'function'
      ? MAEWhatAreYourExpensesRelatedTo.toJS()
      : MAEWhatAreYourExpensesRelatedTo || [];

    const isMedicalHospitalExpensesSelected = medicalAndEvacuationSCTISelected.includes('Medical & Hospital Expenses');
    const isDentalExpensesSelected = medicalAndEvacuationSCTISelected.includes('Dental Expenses');
    const isFuneralExpensesSelected = medicalAndEvacuationSCTISelected.includes('Funeral Expenses');
    const isExpensesarisingfromterrorismSelected = medicalAndEvacuationSCTISelected.includes('Expenses arising from terrorism');
    const isExtraTravelAndAccommodationSelected = MAEWhatAreYourExpensesRelatedToSelected.includes('Extra travel and accommodation');
    // const isInternationalStudent = policyTypeCode === 'INT-ST-NZ';
    // const isVisitingNewZealand = policyTypeVisitingNZ.includes(policyTypeCode);
    // const policyTypeWorkingOverseas = ['WORK-AU', 'WORK-NZ'];
    // const isWorkingOverseas = policyTypeWorkingOverseas.includes(policyTypeCode);
    // const isShowSubBenefits = isInternationalStudent || isVisitingNewZealand || isWorkingOverseas;

    // Medical and Evacuation SCTI - use mapToClaimExpensesLevel to include expenses
    const selectedBenefitsMedicalAndEvacuationSCTI = stepMedicalAndEvacuationSCTIDataMapper.mapToClaimExpensesLevel(this.props.stepMedicalAndEvacuationSCTIData, claimTypesInit, selectedBenefits);
    if (selectedBenefitsMedicalAndEvacuationSCTI.length > 0) {
      list.push(...selectedBenefitsMedicalAndEvacuationSCTI);
    }

    // Baggage and personal items SCTI - use mapToClaimExpensesLevel to include expenses
    const selectedBenefitsBaggageAndPersonalItemsSCTI = stepBaggageAndPersonalItemsSCTIDataMapper.mapToClaimExpensesLevel(this.props.stepBaggageAndPersonalItemsSCTIData, claimTypesInit, selectedBenefits, policyTypeCode);
    if (selectedBenefitsBaggageAndPersonalItemsSCTI.length > 0) {
      list.push(...selectedBenefitsBaggageAndPersonalItemsSCTI);
    }

    // Changes to your journey SCTI - use mapToClaimExpensesLevel to include expenses
    const selectedBenefitsChangesToYourJourneySCTI = stepChangesToYourJourneySCTIDataMapper.mapToClaimExpensesLevel(this.props.stepChangesToYourJourneySCTIData, claimTypesInit, selectedBenefits);
    if (selectedBenefitsChangesToYourJourneySCTI.length > 0) {
      list.push(...selectedBenefitsChangesToYourJourneySCTI);
    }

    // Bank Cards or travel documents and Cash SCTI
    const cashBankCardsTravelDocumentsAndPassportsSelected = !!passportItemsClaiming && typeof passportItemsClaiming.toJS === 'function'
      ? passportItemsClaiming.toJS()
      : passportItemsClaiming || [];
    const isPassportsBankCardsOrTravelDocumentsSelected = cashBankCardsTravelDocumentsAndPassportsSelected.includes('Bank cards or travel documents');
    const isPassportsCashSelected = cashBankCardsTravelDocumentsAndPassportsSelected.includes('Cash');

    if ((isPassportsBankCardsOrTravelDocumentsSelected || isPassportsCashSelected) && claimTypesInit !== undefined) {
      // const baggageAndPersonalItemsCode = stepCashBankCardsTravelDocumentsAndPassportsLookup.baggageAndPersonalItems.claimCode;
      const bankCardsOrTravelDocumentsCode = stepCashBankCardsTravelDocumentsAndPassportsLookup.bankCardsOrTravelDocuments.claimCode;
      // const cashCode = stepCashBankCardsTravelDocumentsAndPassportsLookup.cash.claimCode;

      claimTypesInit.forEach(
        (item) => {
          if (item.claimCode === bankCardsOrTravelDocumentsCode && (isPassportsBankCardsOrTravelDocumentsSelected || isPassportsCashSelected)) {
            const benefit = this.mapQuestionItem(item, 'Cash, bank cards, travel documents and passports');
            if (!!benefit) {
              list.push(benefit);
            }
          }
        }
      );
    }

    // Medical Expenses Tugo
    const {
      whatExpensesAreYouClaimingFor: whatExpensesAreYouClaimingForMedicalExpensesTugo,
      isClaimRelatedToSelfInflictedYes,
      isClaimRelatedToSelfInflictedNo,
      isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt,
      isYourClaimRelatedToPsychiatricTreatment,
      isYourClaimRelatedToHIV,
      diagnosticImaging,
    } = this.props.stepMedicalExpensesTugoData;

    const medicalExpensesTugoSelected = !!whatExpensesAreYouClaimingForMedicalExpensesTugo && typeof whatExpensesAreYouClaimingForMedicalExpensesTugo.toJS === 'function'
      ? whatExpensesAreYouClaimingForMedicalExpensesTugo.toJS()
      : whatExpensesAreYouClaimingForMedicalExpensesTugo || [];

    const isClaimRelatedToSelfInflictedYesChecked = isClaimRelatedToSelfInflictedYes === 'true' || isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt === 'yes';
    const isClaimRelatedToSelfInflictedNoChecked = isClaimRelatedToSelfInflictedNo === 'true';

    const isNonMRIChecked = diagnosticImaging.includes('diagnosticNonMRI');
    const isMRIChecked = diagnosticImaging.includes('diagnosticMRI');

    const isMaternityExpenseSelected = medicalExpensesTugoSelected.includes('Maternity Expense');
    const isOncologySelected = medicalExpensesTugoSelected.includes('Oncology');
    const isCleftLipAndPalateAssistanceSelected = medicalExpensesTugoSelected.includes('Cleft Lip and Palate Assistance');
    const isWellBabyCareSelected = medicalExpensesTugoSelected.includes('Well Baby Care');
    const isAnnualHealthExamSelected = medicalExpensesTugoSelected.includes('Annual Health Exam');
    const isVaccinationExpensesSelected = medicalExpensesTugoSelected.includes('Vaccination Expenses');
    const isbloodPlasmaOrWholeBloodTransfusionSelected = medicalExpensesTugoSelected.includes('Blood plasma or whole blood (transfusion)');
    const isAnaesthesiologySelected = medicalExpensesTugoSelected.includes('Anaesthesiology');
    const isDentalSurgerySelected = medicalExpensesTugoSelected.includes('Dental Surgery');

    const isYourClaimRelatedToPsychiatricTreatmentChecked = isYourClaimRelatedToPsychiatricTreatment === 'yes';
    const isYourClaimRelatedToHIVChecked = isYourClaimRelatedToHIV === 'yes';
    const isHospitalizationChargesChecked = isYourClaimRelatedToHIV === 'no';


    if (medicalExpensesTugoSelected.length > 0 && claimTypesInit !== undefined) {
      const outpatientDoctorOrClinicVisitCode = stepMedicalExpensesTugoLookup.outpatientDoctorOrClinicVisit.claimCode;
      const isClaimRelatedToSelfInflictedCode = stepMedicalExpensesTugoLookup.isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttemptYes.claimCode;

      const diagnosticMRICode = stepMedicalExpensesTugoLookup.diagnosticMRI.claimCode;
      const diagnosticNonMRICode = stepMedicalExpensesTugoLookup.diagnosticNonMRI.claimCode;

      const maternityExpenseCode = stepMedicalExpensesTugoLookup.maternityExpense.claimCode;
      const oncologyCode = stepMedicalExpensesTugoLookup.oncology.claimCode;
      const cleftLipAndPalateAssistanceCode = stepMedicalExpensesTugoLookup.cleftLipAndPalateAssistance.claimCode;
      const wellBabyCareCode = stepMedicalExpensesTugoLookup.wellBabyCare.claimCode;
      const annualHealthExamCode = stepMedicalExpensesTugoLookup.annualHealthExam.claimCode;
      const vaccinationExpensesCode = stepMedicalExpensesTugoLookup.vaccinationExpenses.claimCode;
      const psychiatricTreatmentCode = stepMedicalExpensesTugoLookup.isYourClaimRelatedToPsychiatricTreatment.claimCode;
      const HIVCode = stepMedicalExpensesTugoLookup.isYourClaimRelatedToHIV.claimCode;
      const bloodPlasmaOrWholeBloodTransfusionCode = stepMedicalExpensesTugoLookup.bloodPlasmaOrWholeBloodTransfusion.claimCode;
      const anaesthesiologyCode = stepMedicalExpensesTugoLookup.anaesthesiology.claimCode;
      const dentalSurgeryCode = stepMedicalExpensesTugoLookup.dentalSurgery.claimCode;


      claimTypesInit.forEach(
        (item) => {
          if (item.claimCode === outpatientDoctorOrClinicVisitCode && isClaimRelatedToSelfInflictedNoChecked) {
            const benefit = this.mapQuestionItem(item, 'Outpatient Doctor or Clinic Visit');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === isClaimRelatedToSelfInflictedCode && isClaimRelatedToSelfInflictedYesChecked) {
            const benefit = this.mapQuestionItem(item, 'Self Inflicted Injuries and Attempted Suicide');
            if (!!benefit) {
              list.push(benefit);
            }
          }

          if (item.claimCode === diagnosticMRICode && isMRIChecked) {
            const benefit = this.mapQuestionItem(item, 'MRI Scans');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === diagnosticNonMRICode && isNonMRIChecked) {
            const benefit = this.mapQuestionItem(item, 'Standard X-Ray and Laboratory Examinations');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === maternityExpenseCode && isMaternityExpenseSelected) {
            const benefit = this.mapQuestionItem(item, 'Maternity Expense');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === oncologyCode && isOncologySelected) {
            const benefit = this.mapQuestionItem(item, 'Oncology');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === cleftLipAndPalateAssistanceCode && isCleftLipAndPalateAssistanceSelected) {
            const benefit = this.mapQuestionItem(item, 'Cleft Lip and Palate Assistance');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === wellBabyCareCode && isWellBabyCareSelected) {
            const benefit = this.mapQuestionItem(item, 'Well Baby Care');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === annualHealthExamCode && isAnnualHealthExamSelected) {
            const benefit = this.mapQuestionItem(item, 'Annual Health Exam');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === vaccinationExpensesCode && isVaccinationExpensesSelected) {
            const benefit = this.mapQuestionItem(item, 'Vaccination Expenses');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === psychiatricTreatmentCode && isYourClaimRelatedToPsychiatricTreatmentChecked) {
            const benefit = this.mapQuestionItem(item, 'Hospital Charges Related to Psychiatric Treatment');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === HIVCode && isYourClaimRelatedToHIVChecked) {
            const benefit = this.mapQuestionItem(item, 'Hospital Charges Related to HIV');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === HIVCode && isHospitalizationChargesChecked) {
            const benefit = this.mapQuestionItem(item, 'Hospitalization Charges');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === bloodPlasmaOrWholeBloodTransfusionCode && isbloodPlasmaOrWholeBloodTransfusionSelected) {
            const benefit = this.mapQuestionItem(item, 'Blood plasma or whole blood (transfusion)');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === anaesthesiologyCode && isAnaesthesiologySelected) {
            const benefit = this.mapQuestionItem(item, 'Anaesthesiology');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === dentalSurgeryCode && isDentalSurgerySelected) {
            const benefit = this.mapQuestionItem(item, 'Dental Surgery');
            if (!!benefit) {
              list.push(benefit);
            }
          }
        }
      );
    }

    // Other Expenses Tugo
    const selectedBenefitsOtherTugo = stepOtherTugoDataMapper.mapToClaimExpensesLevel(this.props.stepOtherTugoData, claimTypesInit, selectedBenefits);
    if (selectedBenefitsOtherTugo.length > 0) {
      list.push(...selectedBenefitsOtherTugo);
    }

    // Tugo Benefits
    const selectedBenefitsBaseVictorsMedical = stepBaseVictorsMedicalTugoDataMapper.mapToClaimExpensesLevel(this.props.stepBaseVictorsMedicalTugoData, claimTypesInit, selectedBenefits);
    // Medical Expenses Tugo
    if (selectedBenefitsBaseVictorsMedical.length > 0) {
      list.push(...selectedBenefitsBaseVictorsMedical);
    }

    return list;
  }

  renderUploadAreaForBenefits = (listDocuments, attachDocuments, onAttachDocumentChange, onAttachRequiredDocumentChange, onFileRemove, isReadOnly) => {
    const { claimTypesInit, jsonVersion, showRequiredDocument, policyTypeCode, showZurichUHC } = this.props;
    const isInternationalStudent = policyTypeCode === 'INT-ST-NZ';
    const isVisitingNewZealand = SCTI_VISITING_NEW_ZEALAND_POLICY_TYPES.includes(policyTypeCode);
    const policyTypeWorkingOverseas = ['WORK-AU', 'WORK-NZ'];
    const isWorkingOverseas = policyTypeWorkingOverseas.includes(policyTypeCode);
    const isShowSubBenefits = isInternationalStudent || isVisitingNewZealand || isWorkingOverseas;
    const newVersion = jsonVersion > 10 && showRequiredDocument;
    const { selectedBenefits } = this.props.stepWhatHappenedData;
    // Trawick Benefits
    const { travelInterruption, tripCancellation, tripCancellationForAnyReason } = this.props.stepTripCancellationAndTripInterruptionData;
    const { travelDelay } = this.props.stepTravelDelayData;
    const { travelDelay: tripDelay } = this.props.stepTripDelayData;
    const { tripCancellation: tripCancellationCF, travelDelay: travelDelayCF, travelInterruption: travelInterruptionCF } = this.props.stepTripCancellationCFData;
    const { areYouClaimingForAccidentalDeathAndDismemberment, areYouClaimingForRepatriationExpenses, areYouClaimingForBurialExpenses, whatExpensesAreYouClaimingFor, whatAreYourExpensesRelatedTo } = this.props.stepOtherData;
    const { didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised, wasTheDeathCausedByAnInjury, whatExpensesAreYouClaimingFor: whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI, whatAreYourExpensesRelatedTo: MAEWhatAreYourExpensesRelatedTo } = this.props.stepMedicalAndEvacuationSCTIData;
    const { whatHappenedToYourBaggageAndPersonalItems, whatItemsAreYouClaimingFor } = this.props.stepBaggageAndPersonalItemsSCTIData;
    const { whatItemsAreYouClaimingFor: passportItemsClaiming } = this.props.stepCashBankCardsTravelDocumentsAndPassportsData;
    const { haveYouCanceledOrChangedYourJourneyBeforeLeaving, haveYouChangedYourJourneyAfterLeaving, wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition,
      wereYouChargedACancellationFeeByTheTravelAgent, wereYouDelayedWhileTravelingToASpecialEvent, wereYouDelayedWhileTravelingToASpecialEventAL,
      didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption, wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL } = this.props.stepChangesToYourJourneySCTIData;
    // Trawick UI
    const selectedBenefitsChangesToYourJourney = stepChangesToYourJourneyDataMapper.mapToClaimExpensesLevel(this.props.stepChangesToYourJourneyData, claimTypesInit, selectedBenefits);
    const selectedBenefitsMedicalExpense = stepMedicalExpenseCFDataMapper.mapToClaimExpensesLevel(this.props.stepMedicalExpenseCFData, claimTypesInit, selectedBenefits);
    const selectedBenefitsBaggageAndPersonalItems = stepBaggageAndPersonalItemsDataMapper.mapToClaimExpensesLevel(this.props.stepBaggageAndPersonalItemsData, claimTypesInit, selectedBenefits);
    const selectedBenefitsBaggageAndPersonalItemsStarr = stepBaggageAndPersonalItemsStarrDataMapper.mapToClaimExpensesLevel(this.props.stepBaggageAndPersonalItemsStarrData, claimTypesInit, selectedBenefits);
    const selectedBenefitsOtherStarr = stepOtherDataStarrMapper.mapToClaimExpensesLevel(this.props.stepOtherStarrData, claimTypesInit, selectedBenefits);
    const selectedBenefitsCollisionDamage = stepCollisionDamageDataMapper.mapToClaimExpensesLevel(this.props.stepCollisionDamageData, claimTypesInit, selectedBenefits);
    const selectedBenefitsCollisionDamageStarr = stepCollisionDamageStarrDataMapper.mapToClaimExpensesLevel(this.props.stepCollisionDamageStarrData, claimTypesInit, selectedBenefits);

    const expensesPersonalLiabilitySelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    const whatAreYourExpensesRelatedToSelected = !!whatAreYourExpensesRelatedTo && typeof whatAreYourExpensesRelatedTo.toJS === 'function'
      ? whatAreYourExpensesRelatedTo.toJS()
      : whatAreYourExpensesRelatedTo || [];
    const isPersonalLiabilitySelected = expensesPersonalLiabilitySelected.includes('Personal Liability');
    const isPersonalAccidentSelected = expensesPersonalLiabilitySelected.includes('Personal Accident');
    const isLossOfIncomeCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Loss of Income');
    const isTotalPermanentDisablementCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Total permanent disablement');
    const isLossOfLifeCodeSelected = whatAreYourExpensesRelatedToSelected.includes('Loss of Life');
    const list = [...(!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || [])]
      .filter((x) => x.description !== 'Other'
        && x.description !== 'Trip Cancellation & Trip Interruption'
        && x.description !== 'Medical and evacuation'
        && x.description !== 'Baggage and personal items' // SCTI
        && x.description !== 'Baggage and Personal Items' // Trawick
        && x.description !== 'Changes to your journey'
        && x.description !== 'Cash, bank cards, travel documents and passports'
        && x.description !== 'Collision Damage'
        && x.description !== 'Medical Expenses'
        && x.description !== 'Medical Expenses - Visitors to Canada'
        && x.description !== 'Medical Expense');

    // Collision Damage
    if (selectedBenefitsCollisionDamage.length > 0) {
      list.push(...selectedBenefitsCollisionDamage);
    }

    // Collision Damage Starr
    if (selectedBenefitsCollisionDamageStarr.length > 0) {
      list.push(...selectedBenefitsCollisionDamageStarr);
    }

    // Baggage and personal items Trawick
    if (selectedBenefitsBaggageAndPersonalItems.length > 0) {
      list.push(...selectedBenefitsBaggageAndPersonalItems);
    }

    // Other Documents
    if ((areYouClaimingForRepatriationExpenses === 'true' || areYouClaimingForAccidentalDeathAndDismemberment === 'true' || areYouClaimingForBurialExpenses === 'true'
      || isPersonalLiabilitySelected || isPersonalAccidentSelected || isLossOfIncomeCodeSelected || isLossOfLifeCodeSelected || isTotalPermanentDisablementCodeSelected) && claimTypesInit !== undefined) {
      const code1 = stepOtherExpenseLookup.areYouClaimingForRepatriationExpenses.claimCode;
      const code2 = stepOtherExpenseLookup.areYouClaimingForAccidentalDeathAndDismemberment.claimCode;
      const code3 = stepOtherExpenseLookup.areYouClaimingForBurialExpenses.claimCode;
      const code4 = stepOtherExpenseLookup.personalLiability.claimCode;
      const code5 = stepOtherExpenseLookup.personalAccident.claimCode;
      const lossOfIncomeCode = stepOtherExpenseLookup.lossOfIncome.claimCode;
      const lossOfLifeCode = stepOtherExpenseLookup.lossOfLife.claimCode;
      const totalPermanentDisablementCode = stepOtherExpenseLookup.totalPermanentDisablement.claimCode;
      claimTypesInit.forEach(
        (item) => {
          if (item.claimCode === code1 && areYouClaimingForRepatriationExpenses === 'true') {
            const benefit = this.mapQuestionItem(item, 'Repatriation Expenses');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code2 && areYouClaimingForAccidentalDeathAndDismemberment === 'true') {
            const benefit = this.mapQuestionItem(item, 'Accidental Death & Dismemberment');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code3 && areYouClaimingForBurialExpenses === 'true') {
            const benefit = this.mapQuestionItem(item, 'Burial Expenses');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code4 && isPersonalLiabilitySelected) {
            const benefit = this.mapQuestionItem(item, 'Personal Liability');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code5 && isPersonalAccidentSelected) {
            const benefit = this.mapQuestionItem(item, 'Personal Accident');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === lossOfIncomeCode && isLossOfIncomeCodeSelected) {
            const benefit = this.mapQuestionItem(item, 'Loss of income');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === lossOfLifeCode && isLossOfLifeCodeSelected) {
            const benefit = this.mapQuestionItem(item, 'Loss of Life');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === totalPermanentDisablementCode && isTotalPermanentDisablementCodeSelected) {
            const benefit = this.mapQuestionItem(item, 'Total permanent disablement');
            if (!!benefit) {
              list.push(benefit);
            }
          }
        }
      );
    }

    // Trip Interruption
    if ((tripCancellation === 'true' || tripCancellationForAnyReason === 'true' || travelInterruption === 'true') && claimTypesInit !== undefined) {
      const code1 = stepTripCancellationAndTripInterruptionExpenseLookup.tripCancellation.claimCode;
      const code2 = stepTripCancellationAndTripInterruptionExpenseLookup.tripCancellationForAnyReason.claimCode;
      const code3 = stepTripCancellationAndTripInterruptionExpenseLookup.travelInterruption.claimCode;
      claimTypesInit.forEach(
        (item) => {
          if (item.claimCode === code1 && tripCancellation === 'true') {
            const benefit = this.mapQuestionItem(item, 'Trip Cancellation');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code2 && tripCancellationForAnyReason === 'true') {
            const benefit = this.mapQuestionItem(item, 'Trip Cancellation For Any Reason');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === code3 && travelInterruption === 'true') {
            const benefit = this.mapQuestionItem(item, 'Trip Interruption');
            if (!!benefit) {
              list.push(benefit);
            }
          }
        }
      );
    }

    // Changes To Your Journey Trawick
    if (selectedBenefitsChangesToYourJourney.length > 0) {
      list.push(...selectedBenefitsChangesToYourJourney);
    }

    // Medical Expense Trawick
    if (selectedBenefitsMedicalExpense.length > 0) {
      list.push(...selectedBenefitsMedicalExpense);
    }

    // Baggage and personal items Starr
    if (selectedBenefitsBaggageAndPersonalItemsStarr.length > 0) {
      list.push(...selectedBenefitsBaggageAndPersonalItemsStarr);
    }

    // Other Documents Starr
    if (selectedBenefitsOtherStarr.length > 0) {
      list.push(...selectedBenefitsOtherStarr);
    }

    // Medical and Evacuation SCTI
    const medicalAndEvacuationSCTISelected = !!whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI && typeof whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI.toJS === 'function'
      ? whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI.toJS()
      : whatExpensesAreYouClaimingForMedicalAndEvacuationSCTI || [];

    const MAEWhatAreYourExpensesRelatedToSelected = !!MAEWhatAreYourExpensesRelatedTo && typeof MAEWhatAreYourExpensesRelatedTo.toJS === 'function'
      ? MAEWhatAreYourExpensesRelatedTo.toJS()
      : MAEWhatAreYourExpensesRelatedTo || [];

    const isMedicalHospitalExpensesSelected = medicalAndEvacuationSCTISelected.includes('Medical & Hospital Expenses');
    const isDentalExpensesSelected = medicalAndEvacuationSCTISelected.includes('Dental Expenses');
    const isFuneralExpensesSelected = medicalAndEvacuationSCTISelected.includes('Funeral Expenses');
    const isExpensesarisingfromterrorismSelected = medicalAndEvacuationSCTISelected.includes('Expenses arising from terrorism');
    const isExtraTravelAndAccommodationSelected = MAEWhatAreYourExpensesRelatedToSelected.includes('Extra travel and accommodation');

    // Medical and Evacuation SCTI - use mapToClaimExpensesLevel to include expenses
    const selectedBenefitsMedicalAndEvacuationSCTI2 = stepMedicalAndEvacuationSCTIDataMapper.mapToClaimExpensesLevel(this.props.stepMedicalAndEvacuationSCTIData, claimTypesInit, selectedBenefits);
    if (selectedBenefitsMedicalAndEvacuationSCTI2.length > 0) {
      list.push(...selectedBenefitsMedicalAndEvacuationSCTI2);
    }

    // Baggage and personal items SCTI - use mapToClaimExpensesLevel to include expenses
    const selectedBenefitsBaggageAndPersonalItemsSCTI2 = stepBaggageAndPersonalItemsSCTIDataMapper.mapToClaimExpensesLevel(this.props.stepBaggageAndPersonalItemsSCTIData, claimTypesInit, selectedBenefits, policyTypeCode);
    if (selectedBenefitsBaggageAndPersonalItemsSCTI2.length > 0) {
      list.push(...selectedBenefitsBaggageAndPersonalItemsSCTI2);
    }

    // Changes to your journey SCTI - use mapToClaimExpensesLevel to include expenses
    const selectedBenefitsChangesToYourJourneySCTI2 = stepChangesToYourJourneySCTIDataMapper.mapToClaimExpensesLevel(this.props.stepChangesToYourJourneySCTIData, claimTypesInit, selectedBenefits);
    if (selectedBenefitsChangesToYourJourneySCTI2.length > 0) {
      list.push(...selectedBenefitsChangesToYourJourneySCTI2);
    }

    // Bank Cards or travel documents and Cash SCTI
    const cashBankCardsTravelDocumentsAndPassportsSelected = !!passportItemsClaiming && typeof passportItemsClaiming.toJS === 'function'
      ? passportItemsClaiming.toJS()
      : passportItemsClaiming || [];
    const isPassportsBankCardsOrTravelDocumentsSelected = cashBankCardsTravelDocumentsAndPassportsSelected.includes('Bank cards or travel documents');
    const isPassportsCashSelected = cashBankCardsTravelDocumentsAndPassportsSelected.includes('Cash');

    if ((isPassportsBankCardsOrTravelDocumentsSelected || isPassportsCashSelected) && claimTypesInit !== undefined) {
      const bankCardsOrTravelDocumentsCode = stepCashBankCardsTravelDocumentsAndPassportsLookup.bankCardsOrTravelDocuments.claimCode;
      claimTypesInit.forEach(
        (item) => {
          if (item.claimCode === bankCardsOrTravelDocumentsCode && (isPassportsBankCardsOrTravelDocumentsSelected || isPassportsCashSelected)) {
            const benefit = this.mapQuestionItem(item, 'Cash, bank cards, travel documents and passports');
            if (!!benefit) {
              list.push(benefit);
            }
          }
        }
      );
    }


    // Medical Expenses Tugo
    const {
      whatExpensesAreYouClaimingFor: whatExpensesAreYouClaimingForMedicalExpensesTugo,
      isClaimRelatedToSelfInflictedYes,
      isClaimRelatedToSelfInflictedNo,
      isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt,
      isYourClaimRelatedToPsychiatricTreatment,
      isYourClaimRelatedToHIV,
      diagnosticImaging,
    } = this.props.stepMedicalExpensesTugoData;

    const medicalExpensesTugoSelected = !!whatExpensesAreYouClaimingForMedicalExpensesTugo && typeof whatExpensesAreYouClaimingForMedicalExpensesTugo.toJS === 'function'
      ? whatExpensesAreYouClaimingForMedicalExpensesTugo.toJS()
      : whatExpensesAreYouClaimingForMedicalExpensesTugo || [];

    // const isOutpatientDoctorOrClinicVisitSelected = medicalExpensesTugoSelected.includes('Outpatient Doctor or Clinic Visit');
    const isClaimRelatedToSelfInflictedYesChecked = isClaimRelatedToSelfInflictedYes === 'true' || isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt === 'yes';
    const isClaimRelatedToSelfInflictedNoChecked = isClaimRelatedToSelfInflictedNo === 'true';

    // const isDiagnosticImagingSelected = medicalExpensesTugoSelected.includes('Diagnostic Imaging');
    const isNonMRIChecked = diagnosticImaging.includes('diagnosticNonMRI');
    const isMRIChecked = diagnosticImaging.includes('diagnosticMRI');

    const isMaternityExpenseSelected = medicalExpensesTugoSelected.includes('Maternity Expense');
    const isOncologySelected = medicalExpensesTugoSelected.includes('Oncology');
    const isCleftLipAndPalateAssistanceSelected = medicalExpensesTugoSelected.includes('Cleft Lip and Palate Assistance');
    const isWellBabyCareSelected = medicalExpensesTugoSelected.includes('Well Baby Care');
    const isAnnualHealthExamSelected = medicalExpensesTugoSelected.includes('Annual Health Exam');
    const isVaccinationExpensesSelected = medicalExpensesTugoSelected.includes('Vaccination Expenses');
    const isbloodPlasmaOrWholeBloodTransfusionSelected = medicalExpensesTugoSelected.includes('Blood plasma or whole blood (transfusion)');
    const isAnaesthesiologySelected = medicalExpensesTugoSelected.includes('Anaesthesiology');
    const isDentalSurgerySelected = medicalExpensesTugoSelected.includes('Dental Surgery');

    const isYourClaimRelatedToPsychiatricTreatmentChecked = isYourClaimRelatedToPsychiatricTreatment === 'yes';
    const isYourClaimRelatedToHIVChecked = isYourClaimRelatedToHIV === 'yes';
    const isHospitalizationChargesChecked = isYourClaimRelatedToHIV === 'no';


    if (medicalExpensesTugoSelected.length > 0 && claimTypesInit !== undefined) {
      const outpatientDoctorOrClinicVisitCode = stepMedicalExpensesTugoLookup.outpatientDoctorOrClinicVisit.claimCode;
      const isClaimRelatedToSelfInflictedCode = stepMedicalExpensesTugoLookup.isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttemptYes.claimCode;

      const diagnosticMRICode = stepMedicalExpensesTugoLookup.diagnosticMRI.claimCode;
      const diagnosticNonMRICode = stepMedicalExpensesTugoLookup.diagnosticNonMRI.claimCode;

      const maternityExpenseCode = stepMedicalExpensesTugoLookup.maternityExpense.claimCode;
      const oncologyCode = stepMedicalExpensesTugoLookup.oncology.claimCode;
      const cleftLipAndPalateAssistanceCode = stepMedicalExpensesTugoLookup.cleftLipAndPalateAssistance.claimCode;
      const wellBabyCareCode = stepMedicalExpensesTugoLookup.wellBabyCare.claimCode;
      const annualHealthExamCode = stepMedicalExpensesTugoLookup.annualHealthExam.claimCode;
      const vaccinationExpensesCode = stepMedicalExpensesTugoLookup.vaccinationExpenses.claimCode;
      const psychiatricTreatmentCode = stepMedicalExpensesTugoLookup.isYourClaimRelatedToPsychiatricTreatment.claimCode;
      const HIVCode = stepMedicalExpensesTugoLookup.isYourClaimRelatedToHIV.claimCode;
      const bloodPlasmaOrWholeBloodTransfusionCode = stepMedicalExpensesTugoLookup.bloodPlasmaOrWholeBloodTransfusion.claimCode;
      const anaesthesiologyCode = stepMedicalExpensesTugoLookup.anaesthesiology.claimCode;
      const dentalSurgeryCode = stepMedicalExpensesTugoLookup.dentalSurgery.claimCode;

      claimTypesInit.forEach(
        (item) => {
          if (item.claimCode === outpatientDoctorOrClinicVisitCode && isClaimRelatedToSelfInflictedNoChecked) {
            const benefit = this.mapQuestionItem(item, 'Outpatient Doctor or Clinic Visit');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === isClaimRelatedToSelfInflictedCode && isClaimRelatedToSelfInflictedYesChecked) {
            const benefit = this.mapQuestionItem(item, 'Self Inflicted Injuries and Attempted Suicide');
            if (!!benefit) {
              list.push(benefit);
            }
          }

          if (item.claimCode === diagnosticMRICode && isMRIChecked) {
            const benefit = this.mapQuestionItem(item, 'MRI Scans');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === diagnosticNonMRICode && isNonMRIChecked) {
            const benefit = this.mapQuestionItem(item, 'Standard X-Ray and Laboratory Examinations');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === maternityExpenseCode && isMaternityExpenseSelected) {
            const benefit = this.mapQuestionItem(item, 'Maternity Expense');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === oncologyCode && isOncologySelected) {
            const benefit = this.mapQuestionItem(item, 'Oncology');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === cleftLipAndPalateAssistanceCode && isCleftLipAndPalateAssistanceSelected) {
            const benefit = this.mapQuestionItem(item, 'Cleft Lip and Palate Assistance');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === wellBabyCareCode && isWellBabyCareSelected) {
            const benefit = this.mapQuestionItem(item, 'Well Baby Care');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === annualHealthExamCode && isAnnualHealthExamSelected) {
            const benefit = this.mapQuestionItem(item, 'Annual Health Exam');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === vaccinationExpensesCode && isVaccinationExpensesSelected) {
            const benefit = this.mapQuestionItem(item, 'Vaccination Expenses');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === psychiatricTreatmentCode && isYourClaimRelatedToPsychiatricTreatmentChecked) {
            const benefit = this.mapQuestionItem(item, 'Hospital Charges Related to Psychiatric Treatment');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === HIVCode && isYourClaimRelatedToHIVChecked) {
            const benefit = this.mapQuestionItem(item, 'Hospital Charges Related to HIV');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === HIVCode && isHospitalizationChargesChecked) {
            const benefit = this.mapQuestionItem(item, 'Hospitalization Charges');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === bloodPlasmaOrWholeBloodTransfusionCode && isbloodPlasmaOrWholeBloodTransfusionSelected) {
            const benefit = this.mapQuestionItem(item, 'Blood plasma or whole blood (transfusion)');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === anaesthesiologyCode && isAnaesthesiologySelected) {
            const benefit = this.mapQuestionItem(item, 'Anaesthesiology');
            if (!!benefit) {
              list.push(benefit);
            }
          }
          if (item.claimCode === dentalSurgeryCode && isDentalSurgerySelected) {
            const benefit = this.mapQuestionItem(item, 'Dental Surgery');
            if (!!benefit) {
              list.push(benefit);
            }
          }
        }
      );
    }

    // Other Expenses Tugo
    const selectedBenefitsOtherTugo = stepOtherTugoDataMapper.mapToClaimExpensesLevel(this.props.stepOtherTugoData, claimTypesInit, selectedBenefits);
    if (selectedBenefitsOtherTugo.length > 0) {
      list.push(...selectedBenefitsOtherTugo);
    }

    // Tugo Benefits
    const selectedBenefitsBaseVictorsMedical = stepBaseVictorsMedicalTugoDataMapper.mapToClaimExpensesLevel(this.props.stepBaseVictorsMedicalTugoData, claimTypesInit, selectedBenefits);
    // Medical Expenses Tugo
    if (selectedBenefitsBaseVictorsMedical.length > 0) {
      list.push(...selectedBenefitsBaseVictorsMedical);
    }

    if (!list.length) {
      return null;
    }

    const baggageAndPersonalItemsSelectedForOrder = !!whatHappenedToYourBaggageAndPersonalItems && typeof whatHappenedToYourBaggageAndPersonalItems.toJS === 'function'
      ? whatHappenedToYourBaggageAndPersonalItems.toJS()
      : whatHappenedToYourBaggageAndPersonalItems || [];
    const damagedItemsSelectedForOrder = !!whatItemsAreYouClaimingFor && typeof whatItemsAreYouClaimingFor.toJS === 'function'
      ? whatItemsAreYouClaimingFor.toJS()
      : whatItemsAreYouClaimingFor || [];
    const isDaggageDelaySelected = baggageAndPersonalItemsSelectedForOrder.includes('Baggage delay');
    const isEssentialMedicationSelected = damagedItemsSelectedForOrder.includes('Essential medication');
    const isSpecifiedHighValueItemsSelected = damagedItemsSelectedForOrder.includes('Specified high value items');
    const isBankCardsOrTravelDocumentsSelected = damagedItemsSelectedForOrder.includes('Bank cards or travel documents');
    const isCashSelected = damagedItemsSelectedForOrder.includes('Cash');
    const isJewelleryOrTraditionalWatchesSelected = damagedItemsSelectedForOrder.includes('Jewellery or traditional watches');
    const isUnspecifiedLaptopSelected = damagedItemsSelectedForOrder.includes('Laptops, tablets or cameras');
    const isOtherUnspecifiedItemsSelected = damagedItemsSelectedForOrder.includes('Other unspecified items');

    const didYouAlsoIncurTheseCostsSelected = !!didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption && typeof didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS === 'function'
      ? didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption.toJS()
      : didYouAlsoIncurTheseCostsAsAResultOfYourTravelDisruption || [];
    const isChildCareExpensesSelected = didYouAlsoIncurTheseCostsSelected.includes('Childcare expenses');
    const isPetBoardingFacilitySelected = didYouAlsoIncurTheseCostsSelected.includes('Pet boarding facility');

    let renderStepCancellationAdditional = true;
    let renderStepOverseasMedical = true;
    let renderStepPersonalItems = true;
    let renderStepRentalVehicle = true;
    let renderStepOther = true;
    // need to reorder list
    let flag = false;
    for (let x = 0; x < list.length; x++) {
      if (((stepOverseasMedicalExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 1;
      } else if (((stepCancellationAdditionalExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 3;
      } else if (((stepPersonalItemsExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 2;
      } else if ((Object.values(stepRentalVehicleExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 4;
        // trawick specific sections
        // travel interruption
      } else if (((stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Interruption' && travelInterruption === 'true')).length > 0 && !flag) {
        flag = true;
        list[x].description = 'Trip Interruption';
        list[x].order = 4;
        renderStepRentalVehicle = false;
        renderStepCancellationAdditional = false;
      } else if (((stepBaggageAndPersonalItemsExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 2;
        renderStepPersonalItems = false;
        renderStepCancellationAdditional = false;
        // Accidental Death & Dismemberment
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Accidental Death & Dismemberment' && areYouClaimingForAccidentalDeathAndDismemberment === 'true')).length > 0) {
        list[x].order = 7;
        renderStepOther = false;
        renderStepCancellationAdditional = false;
        // Repatriation Expenses
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Repatriation Expenses' && areYouClaimingForRepatriationExpenses === 'true')).length > 0) {
        list[x].order = 8;
        renderStepOther = false;
        renderStepCancellationAdditional = false;
        // Burial Expenses
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Burial Expenses' && areYouClaimingForBurialExpenses === 'true')).length > 0) {
        list[x].order = 9;
        renderStepOther = false;
        renderStepCancellationAdditional = false;
        // medical expenses
      } else if (!showZurichUHC && ((stepMedicalExpensesExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 1;
        renderStepOverseasMedical = false;
        renderStepCancellationAdditional = false;
        // medical expenses step
      } else if (((stepMedicalExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 10;
        // Trip Cancellation step
      } else if (((stepTripCancellationLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 11;
        // Trip Interruption step
      } else if (((stepTripInterruptionLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 12;
        // Trip Delay step
      } else if (((stepTripDelayLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Delay' && tripDelay === 'true')).length > 0) {
        list[x].order = 13;
        // Missed Connection step
      } else if (((stepMissedConnectionLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 14;
        // Pet Medical step
      } else if (((stepPetMedicalExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 15;
      } else if (((stepPropertyDamageExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 17;
        // Accidental Death and Dismemberment
      } else if (((stepAccidentalDeathAndDismembermentLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 18;
      } else if (((itineraryChangeLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 19;
      } else if (((stepMedicalExpenseCFLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 20;
      } else if (((baggagePersonalEffectsLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 21;
      } else if (((stepTripCancellationCFLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Cancellation' && tripCancellationCF === 'true')).length > 0) {
        list[x].order = 23;
      } else if (((stepTripCancellationCFLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Delay' && travelDelayCF === 'true')).length > 0) {
        list[x].order = 24;
      } else if (((stepTripCancellationCFLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Interruption CF' && travelInterruptionCF === 'true')).length > 0) {
        list[x].description = 'Trip Interruption';
        list[x].order = 25;
      } else if (((jobLossHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 26;
      } else if (((disasterAssistanceHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 27;
      } else if (((medicalHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].claimCode === medicalHardshipLookup.criticalIllness.claimCode)).length > 0) {
        list[x].order = 28;
      } else if (((medicalHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].claimCode === medicalHardshipLookup.disability.claimCode)).length > 0) {
        list[x].order = 29;
      } else if (((medicalHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].claimCode === medicalHardshipLookup.dismemberment.claimCode)).length > 0) {
        list[x].order = 30;
      } else if (((medicalHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].claimCode === medicalHardshipLookup.leaveOfAbsence.claimCode)).length > 0) {
        list[x].order = 31;
      } else if (((medicalHardshipLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].claimCode === medicalHardshipLookup.death.claimCode)).length > 0) {
        list[x].order = 32;
      } else if (((stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Cancellation' && tripCancellation === 'true')).length > 0) {
        list[x].order = 33;
      } else if (((stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Trip Cancellation For Any Reason' && tripCancellationForAnyReason === 'true')).length > 0) {
        list[x].order = 34;
        // travel delay
      } else if (((stepTravelDelayLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Travel Delay & Missed Connections' && travelDelay === 'true')).length > 0) {
        list[x].order = 35;
      } else if (showZurichUHC && ((stepMedicalExpensesExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 36;
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Personal Liability' && isPersonalLiabilitySelected)).length > 0) {
        // Personal Liability
        list[x].order = 39;
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Personal Accident' && isPersonalAccidentSelected)).length > 0) {
        // Personal Accident
        list[x].order = 40;
      } else if (((stepPersonalAccidentSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 41;
      } else if (((stepRentalVehicleExcessSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m)).length > 0) {
        list[x].order = 42;
      } else if (((stepMedicalAndEvacuationLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Medical and evacuation' && (isMedicalHospitalExpensesSelected || isDentalExpensesSelected
        || isExpensesarisingfromterrorismSelected || isFuneralExpensesSelected || isExtraTravelAndAccommodationSelected))).length > 0) {
        // Medical and Evacuation SCTI
        list[x].order = 44;
      } else if (((stepMedicalAndEvacuationLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Accompanying Person' && didAnAccompanyingPersonTravelFromYourHomeCountryWhilstYouWereHospitalised === 'true')).length > 0) {
        list[x].order = 45;
      } else if (((stepMedicalAndEvacuationLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Funeral expenses or return of mortal remains' && isFuneralExpensesSelected)).length > 0) {
        list[x].order = 47;
      } else if (((stepMedicalAndEvacuationLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Loss Of Life' && wasTheDeathCausedByAnInjury === 'true')).length > 0) {
        list[x].order = 48;
      } else if (((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Baggage delay' && isDaggageDelaySelected)).length > 0) {
        // Baggage and Personal Items SCTI
        list[x].order = 49;
      } else if (((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Essential medication' && isEssentialMedicationSelected)).length > 0) {
        list[x].order = 50;
      } else if (((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Specified high value items' && isSpecifiedHighValueItemsSelected)).length > 0) {
        list[x].order = 51;
      } else if (((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Cash, bank cards, travel documents and passports' && (isBankCardsOrTravelDocumentsSelected || isCashSelected))).length > 0) {
        list[x].order = 52;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Cancelling or changing your journey before you leave' && (haveYouCanceledOrChangedYourJourneyBeforeLeaving === 'true' || wereYouChargedACancellationFeeByTheTravelAgent === 'true'))).length > 0) {
        // Changes to your journey SCTI
        list[x].order = 54;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Existing condition of a relevant person' && wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthCondition === 'true')).length > 0) {
        list[x].order = 55;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Travel Agent Cancellation fee' && wereYouChargedACancellationFeeByTheTravelAgent === 'true')).length > 0) {
        list[x].order = 56;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Delayed journey to a special event' && wereYouDelayedWhileTravelingToASpecialEvent === 'true')).length > 0) {
        list[x].order = 57;
        // } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Travel Agent Cancellation fee' && wereYouChargedACancellationFeeByTheTravelAgentPI === 'true')).length > 0) {
        //   list[x].order = 58;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Changes to your journey once you have left' && haveYouChangedYourJourneyAfterLeaving === 'true')).length > 0) {
        // Changes to your journey once you have left
        list[x].order = 59;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Delayed journey to a special event' && wereYouDelayedWhileTravelingToASpecialEventAL === 'true')).length > 0) {
        list[x].order = 60;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Childcare expenses' && isChildCareExpensesSelected)).length > 0) {
        list[x].order = 61;
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Loss of income' && isLossOfIncomeCodeSelected)).length > 0) {
        // Other SCTI
        list[x].order = 62;
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Loss of Life' && isLossOfLifeCodeSelected)).length > 0) {
        list[x].order = 63;
      } else if (((stepOtherExpenseLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Total permanent disablement' && isTotalPermanentDisablementCodeSelected)).length > 0) {
        list[x].order = 64;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Pet services' && isPetBoardingFacilitySelected)).length > 0) {
        // Pet services
        list[x].order = 65;
      } else if (((stepChangesToYourJourneyLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Existing condition of a relevant person' && wasTheUnexpectedEventRelatedToTheRelevantPersonsExistingHealthConditionAL === 'true')).length > 0) {
        // Existing condition of a relevant person
        list[x].order = 69;
      } else if (((stepBaggageAndPersonalItemsSCTILookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Baggage and Personal Items' && (isDaggageDelaySelected || isEssentialMedicationSelected
        || isSpecifiedHighValueItemsSelected || isJewelleryOrTraditionalWatchesSelected || isUnspecifiedLaptopSelected || isOtherUnspecifiedItemsSelected
        || isBankCardsOrTravelDocumentsSelected || isCashSelected))).length > 0) {
        // Baggage and Personal Items
        list[x].order = 70;
      } else if (((stepMedicalAndEvacuationLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Extra travel and accommodation' && isExtraTravelAndAccommodationSelected)).length > 0) {
        // Extra travel and accommodation
        list[x].order = 71;
      } else if (((stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Cash, bank cards, travel documents and passports' && (isPassportsBankCardsOrTravelDocumentsSelected || isPassportsCashSelected))).length > 0) {
        // Bank Cards or travel documents and Cash SCTI
        list[x].order = 72;
      }
      // Medical Expenses Tugo
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Outpatient Doctor or Clinic Visit' && isClaimRelatedToSelfInflictedNoChecked)).length > 0) {
        list[x].order = 84;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Self Inflicted Injuries and Attempt' && isClaimRelatedToSelfInflictedYesChecked)).length > 0) {
        list[x].order = 85;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'MRI Scans' && isMRIChecked)).length > 0) {
        list[x].order = 86;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Standard X-Ray and Laboratory Examinations' && isNonMRIChecked)).length > 0) {
        list[x].order = 87;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Maternity Expense' && isMaternityExpenseSelected)).length > 0) {
        list[x].order = 88;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Oncology' && isOncologySelected)).length > 0) {
        list[x].order = 89;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Cleft Lip and Palate Assistance' && isCleftLipAndPalateAssistanceSelected)).length > 0) {
        list[x].order = 90;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Well Baby Care' && isWellBabyCareSelected)).length > 0) {
        list[x].order = 91;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Annual Health Exam' && isAnnualHealthExamSelected)).length > 0) {
        list[x].order = 92;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Vaccination Expenses' && isVaccinationExpensesSelected)).length > 0) {
        list[x].order = 93;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Hospital Charges Related to Psychiatric Treatment' && isYourClaimRelatedToPsychiatricTreatmentChecked)).length > 0) {
        list[x].order = 94;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Hospital Charges Related to HIV' && isYourClaimRelatedToHIVChecked)).length > 0) {
        list[x].order = 95;
      }
      else if (((stepMedicalExpensesTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Hospitalization Charges' && isHospitalizationChargesChecked)).length > 0) {
        list[x].order = 96;
      }
      else if (((stepOtherTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Blood plasma or whole blood (transfusion)' && isbloodPlasmaOrWholeBloodTransfusionSelected)).length > 0) {
        list[x].order = 97;
      }
      else if (((stepOtherTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Anaesthesiology' && isAnaesthesiologySelected)).length > 0) {
        list[x].order = 98;
      }
      else if (((stepOtherTugoLookup.claimCodeList).filter((m) => list[x].claimCode === m && list[x].description === 'Dental Surgery' && isDentalSurgerySelected)).length > 0) {
        list[x].order = 99;
      }
    }

    // If we have a submittedDocumentsSnapshot, override requiredDocuments for matching claim types
    const snapshot = this.props.form && this.props.form.submittedDocumentsSnapshot;
    let finalList = list;
    if (snapshot && snapshot.documents && Array.isArray(snapshot.documents)) {
      const snapshotByClaimTypeId = snapshot.documents.reduce((acc, item) => {
        if (item && item.claimTypeId) {
          acc[item.claimTypeId] = item.requiredDocuments || [];
        }
        return acc;
      }, {});

      finalList = list.map((item) => {
        const overriddenDocs = snapshotByClaimTypeId[item.claimTypeId];
        if (overriddenDocs) {
          return {
            ...item,
            requiredDocuments: overriddenDocs,
          };
        }
        return item;
      });
    }

    const renderRequireDoccument = (data) => {
      const isScti = appConfig.reactAppEnv === 'scti' || appConfig.reactAppEnv === 'tugo';
      let expenses = data.expenses || [];
      const isExpenseLevelVersion = jsonVersion > 15;
      const { validationMessages } = this.props.form;
      const { jsonVersion } = this.props;
      const { intl } = this.props;

      const documents = (data.requiredDocuments || []).map((doc) => {
        const found = (validationMessages || []).find(
          (msg) => msg.RequiredDocumentId === doc.claimRequiredDocumentId
        );
        return {
          ...doc,
          Message: found ? found.Message : '',
          Success: found ? found.Success : undefined,
        };
      });

      if (!documents) {
        return null;
      }

      const listBenefits = [...(selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || [])];
      const benefit = listBenefits.find((b) => Array.isArray(b.codeList) && b.codeList.includes(data.claimCode)) || {};

      // if (benefit.description === 'Changes to your journey') {
      //   expenses = stepChangesToYourJourneyDataMapper.mapToExpenses(this.props.stepChangesToYourJourneyData);
      // } else if (benefit.description === 'Baggage and Personal Items') {
      //   expenses = stepBaggageAndPersonalItemsStarrDataMapper.mapToExpenses(this.props.stepBaggageAndPersonalItemsStarrData);
      // }
      // else if (benefit.description === 'Medical Expense') {
      //   expenses = stepMedicalExpenseCFDataMapper.mapToExpenses(this.props.stepMedicalExpenseCFData);
      // }

      this.allowValidateDocuments[data.claimTypeId] = expenses.length == 1;
      const hasDocsNeedToValidate = documents.some((doc) => doc.runDocumentValidation === true);
      // Show validation message column when jsonVersion > 15
      const showReviewColumn = jsonVersion > 15 && hasDocsNeedToValidate && this.allowValidateDocuments[data.claimTypeId];
      const hasPendingDocAnywhere = documents.some(doc => doc.Success === null);

      return documents.length > 0 ? (
        <div>
          {isScti
            ? this.renderSCTIRequireDocMessage(documents, data, expenses, showReviewColumn, hasPendingDocAnywhere, attachDocuments, isReadOnly, onAttachRequiredDocumentChange, onFileRemove, intl)
            : this.renderClaimExpenseRequireDocMessage(documents, data, expenses, showReviewColumn, hasPendingDocAnywhere, attachDocuments, isReadOnly, onAttachRequiredDocumentChange, onFileRemove, isExpenseLevelVersion, intl)
          }
        </div>
      ) : (null);
    };

    finalList.sort((a, b) => {
      const aHasRequiredDocuments = a.requiredDocuments && a.requiredDocuments.length > 0;
      const bHasRequiredDocuments = b.requiredDocuments && b.requiredDocuments.length > 0;
      return bHasRequiredDocuments - aHasRequiredDocuments;
    });

    return finalList.map((d, idx) => (
      <div key={idx} style={{ backgroundColor: '#f5f5f5', marginLeft: '5px', marginRight: '5px', display: d.order === 0 ? 'none' : '' }} className={idx > 0 ? 'row pt-3 mt-4' : 'row pt-3'}>
        <div className="form-group col-md-12">
          <span className='normal-text' style={{ fontWeight: '600' }}>
            {d.description.charAt(0).toUpperCase() + d.description.slice(1).toLowerCase()} documents
          </span>
          <span className='normal-text'>- Provide all that are relevant to your claim</span>
        </div>
        {newVersion && d.requiredDocuments && d.requiredDocuments.some(doc => doc.runDocumentValidation === true) && this.renderInstructions()}
        {newVersion &&
          <div style={{ paddingRight: '15px' }}>
            {d.order === 3 && renderRequireDoccument(d) && renderStepCancellationAdditional}
            {d.order === 2 && renderRequireDoccument(d) && renderStepPersonalItems}
            {d.order === 4 && renderRequireDoccument(d) && renderStepRentalVehicle}
            {d.order === 5 && renderRequireDoccument(d) && renderStepOther}
            {/* trawick medical expenses */}
            {d.order === 1 && renderRequireDoccument(d)}
            {/* trawick trip interruption and delay */}
            {d.order === 4 && travelInterruption === 'true' && renderRequireDoccument(d)}
            {/* trawick baggage and personal */}
            {d.order === 2 && renderRequireDoccument(d)}
            {/* trawick other */}
            {d.order === 7 && areYouClaimingForAccidentalDeathAndDismemberment === 'true' && renderRequireDoccument(d)}
            {d.order === 8 && areYouClaimingForRepatriationExpenses === 'true' && renderRequireDoccument(d)}
            {d.order === 9 && areYouClaimingForBurialExpenses === 'true' && renderRequireDoccument(d)}
            {d.order === 10 && renderRequireDoccument(d)}
            {d.order === 11 && renderRequireDoccument(d)}
            {d.order === 12 && renderRequireDoccument(d)}
            {d.order === 13 && renderRequireDoccument(d)}
            {d.order === 14 && renderRequireDoccument(d)}
            {d.order === 15 && renderRequireDoccument(d)}
            {/* {d.order === 16 && renderRequireDoccument(d)} */}
            {d.order === 17 && renderRequireDoccument(d)}
            {d.order === 18 && renderRequireDoccument(d)}
            {d.order === 19 && renderRequireDoccument(d)}
            {d.order === 20 && renderRequireDoccument(d)}
            {d.order === 21 && renderRequireDoccument(d)}
            {d.order === 23 && tripCancellationCF === 'true' && renderRequireDoccument(d)}
            {d.order === 24 && travelDelayCF === 'true' && renderRequireDoccument(d)}
            {d.order === 25 && travelInterruptionCF === 'true' && renderRequireDoccument(d)}
            {d.order === 26 && <JobLossHardshipStepShared />}
            {d.order === 27 && <DisasterAssistanceHardshipStepShared />}
            {d.order === 28 && <CriticalIllnessStepShared />}
            {d.order === 29 && <DisabilityStepShared />}
            {d.order === 30 && <DismembermentStepShared />}
            {d.order === 31 && <LeaveOfAbsenceStepShared />}
            {d.order === 32 && <DeathStepShared />}
            {d.order === 33 && tripCancellation === 'true' && renderRequireDoccument(d)}
            {d.order === 34 && tripCancellationForAnyReason === 'true' && renderRequireDoccument(d)}
            {d.order === 35 && travelDelay === 'true' && renderRequireDoccument(d)}
            {d.order === 39 && renderRequireDoccument(d)}
            {d.order === 40 && renderRequireDoccument(d)}
            {d.order === 41 && renderRequireDoccument(d)}
            {d.order === 42 && renderRequireDoccument(d)}
            {/* {d.order === 43 && renderRequireDoccument(d)} */}
            {/* Medical and Evacuation SCTI */}
            {d.order === 44 && renderRequireDoccument(d)}
            {d.order === 45 && renderRequireDoccument(d)}
            {d.order === 47 && renderRequireDoccument(d)}
            {d.order === 48 && renderRequireDoccument(d)}
            {/* Baggage and Personal Items SCTI */}
            {d.order === 49 && renderRequireDoccument(d)}
            {d.order === 50 && renderRequireDoccument(d)}
            {d.order === 51 && renderRequireDoccument(d)}
            {d.order === 52 && renderRequireDoccument(d)}
            {/* Changes to your journey */}
            {d.order === 54 && renderRequireDoccument(d)}
            {d.order === 55 && renderRequireDoccument(d)}
            {d.order === 56 && renderRequireDoccument(d)}
            {d.order === 57 && renderRequireDoccument(d)}
            {d.order === 58 && renderRequireDoccument(d)}
            {d.order === 59 && renderRequireDoccument(d)}
            {d.order === 60 && renderRequireDoccument(d)}
            {d.order === 61 && renderRequireDoccument(d)}
            {d.order === 62 && renderRequireDoccument(d)}
            {d.order === 63 && renderRequireDoccument(d)}
            {d.order === 64 && renderRequireDoccument(d)}
            {/* Pet services */}
            {d.order === 65 && renderRequireDoccument(d)}
            {/* Cancelling or changing your journey before you leave NZ-EXCON-RP */}
            {d.order === 69 && renderRequireDoccument(d)}
            {/* Baggage and Personal Items */}
            {d.order === 70 && renderRequireDoccument(d)}
            {/* Extra travel and accommodation */}
            {d.order === 71 && renderRequireDoccument(d)}
            {/* // Bank Cards or travel documents and Cash SCTI */}
            {d.order === 72 && renderRequireDoccument(d)}
            {/* Medical Expenses Tugo */}
            {(d.order >= 84 && d.order <= 99) && renderRequireDoccument(d)}
            {/* Other Tugo */}
            {(d.order === null) && renderRequireDoccument(d, attachDocuments)}
          </div>
        }
        {!newVersion &&
          <div style={{ paddingRight: '15px' }}>
            {d.order === 3 && <StepCancellationAdditionalShared /> && renderStepCancellationAdditional}
            {d.order === 2 && <StepPersonalItemsShared /> && renderStepPersonalItems}
            {d.order === 1 && <StepOverseasMedicalShared /> && renderStepOverseasMedical}
            {d.order === 4 && <StepRentalVehicleShared /> && renderStepRentalVehicle}
            {/* {d.order === 6 && <StepSnowSportsShared />} */}
            {d.order === 5 && <StepOtherShared /> && renderStepOther}
            {/* trawick medical expenses */}
            {d.order === 1 && <StepMedicalExpensesShared />}
            {/* trawick trip interruption and delay */}
            {d.order === 4 && travelInterruption === 'true' && <TripInterruptionStepShared />}
            {/* trawick baggage and personal */}
            {d.order === 2 && <StepBaggageAndPersonalItemsShared />}
            {/* trawick other */}
            {/* {d.order === 5 && <Step17Shared />} */}
            {d.order === 7 && areYouClaimingForAccidentalDeathAndDismemberment === 'true' && <StepOtherSharedForAD />}
            {d.order === 8 && areYouClaimingForRepatriationExpenses === 'true' && <StepOtherSharedForRepatriationExpenses />}
            {d.order === 9 && areYouClaimingForBurialExpenses === 'true' && <StepOtherSharedForBurialExpenses />}
            {d.order === 10 && <MedicalExpenseStepShared />}
            {d.order === 11 && <TripCancellationStepShared />}
            {d.order === 12 && <TripInterruptionStepShared />}
            {d.order === 13 && <TripDelayStepShared />}
            {d.order === 14 && <MissedConnectionStepShared />}
            {d.order === 15 && <PetMedicalStepShared />}
            {d.order === 16 && <CollisionDamageStepShared />}
            {d.order === 17 && <PropertyDamageStepShared />}
            {d.order === 18 && <AccidentalDeathAndDismembermentStepShared />}
            {d.order === 19 && <ItineraryChangeStepShared />}
            {d.order === 20 && <MedicalExpenseCFStepShared />}
            {d.order === 21 && <BaggagePersonalEffectsShared />}
            {d.order === 23 && tripCancellationCF === 'true' && <TripCancellationCFStepShared />}
            {d.order === 24 && travelDelayCF === 'true' && <TripDelayCFStepShared />}
            {d.order === 25 && travelInterruptionCF === 'true' && <TripInterruptionCFStepShared />}
            {d.order === 26 && <JobLossHardshipStepShared />}
            {d.order === 27 && <DisasterAssistanceHardshipStepShared />}
            {d.order === 28 && <CriticalIllnessStepShared />}
            {d.order === 29 && <DisabilityStepShared />}
            {d.order === 30 && <DismembermentStepShared />}
            {d.order === 31 && <LeaveOfAbsenceStepShared />}
            {d.order === 32 && <DeathStepShared />}
            {d.order === 33 && tripCancellation === 'true' && <TripCancellationCFStepShared />}
            {d.order === 34 && tripCancellationForAnyReason === 'true' && <TripCancellationCFStepShared />}
            {d.order === 35 && travelDelay === 'true' && <StepTripCancellationAndTripInterruptionSharedTravelDelay />}
            {d.order === 36 && <MedicalExpenseZurichStepShared />}
            {d.order === 39 && isPersonalLiabilitySelected && <StepOtherSharedForRepatriationExpenses />}
            {d.order === 40 && isPersonalAccidentSelected && <StepOtherSharedForBurialExpenses />}
            {d.order === 41 && <StepPersonalAccidentSCTIShared />}
            {d.order === 42 && <StepRentalVehicleExcessSCTIShared />}
            {d.order === 43 && <StepCashBankCardsTravelDocumentsAndPassportsShared />}
            {/* Medical and Evacuation SCTI */}
            {d.order === 44 && <StepMedicalAndEvacuationShared />}
            {/* Baggage and Personal Items SCTI */}
            {d.order === 47 && <StepBaggageAndPersonalItemsSCTIShared />}
            {/* Changes to your journey */}
            {d.order === 52 && <StepChangesToYourJourneyShared />}
          </div>
        }
        <div className="form-group col-md-12">
          <b><FormattedMessage {...messages.SupportingDocs} id={messages.SupportingDocs.id} /></b> - <span className='normal-text'><FormattedMessage {...messages.UploadAny} id={messages.UploadAny.id} /></span>
        </div>
        <div className="form-group col-md-12">
          <AttachSupportingDocuments
            claimCode={d.claimCode}
            data={attachDocuments}
            onChange={onAttachDocumentChange.bind(this, d.claimCode)}
            onDelete={onFileRemove}
            disabled={isReadOnly}
          />
        </div>
      </div>
    ));
  };

  renderInstructions() {
    return (
      <div className="col-md-12 pt-3 px-3">
        <i>Kindly follow instructions carefully:</i>
        <ul className="mt-2">
          <li>For each <b>Document</b> section in the table below, provide relevant supporting documents. Ensure the documents are easy to read and the details match the claim as clearly as possible.</li>
          <li>If necessary, you can attach more than one document per <b>Document</b> row. For example, if your itinerary consists of 3 pages and they have been individually scanned or photographed, attach all 3 in the same <b>Document</b> row.</li>
          <li>Once you have attached all files per <b>Document</b> row, click the blue <b>Check My Documents</b> button. After a few seconds, observe the result and follow the instructions.</li>
          <li>If you receive a red warning block but believe the validation misunderstood or missed something, please ignore the warning and proceed with your claim.</li>
          <li>If you need to update claim details on a different screen or upload a different document, click the blue <b>Check Again</b> button to check for remaining warnings.</li>
        </ul>
      </div>
    );
  }

  getTranslatedDescription = (document, intl) => {
    if (!document || !intl) {
      return document.requiredDocumentDescription || '';
    }
    const locale = intl.locale || 'en';
    if (document.translations && document.translations[locale]) {
      return document.translations[locale];
    }
    return document.requiredDocumentDescription || '';
  }
  renderClaimExpenseRequireDocMessage = (documents, data, expenses, showReviewColumn, hasPendingDocAnywhere, attachDocuments, isReadOnly, onAttachRequiredDocumentChange, onFileRemove, isExpenseLevelVersion, intl) => (
    <div>
      <Table style={{ tableLayout: 'fixed', width: '100%' }}>
        <thead>
          <TR>
            <TH className="document-table-top document-table-left document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: '50%' }}>
              <FormattedMessage {...messages.DocDocument} id={messages.DocDocument.id} />
            </TH>
            <TH className="document-table-top document-table-left align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: showReviewColumn ? '25%' : '50%' }}>
              <FormattedMessage {...messages.DocUploaded} id={messages.DocUploaded.id} />
            </TH>
            <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
              {showReviewColumn && (
                <FormattedMessage {...messages.InitialDocumentReview} id={messages.InitialDocumentReview.id} />
              )}
            </TH>
          </TR>
        </thead>
        {isExpenseLevelVersion &&
          <tbody>
            <TR
              className="no-hover"
              style={{ pointerEvents: 'none' }}
            >
              <TD colSpan={showReviewColumn ? 3 : 3} style={{ border: 'none' }}>
                <Section>
                  <ControlContainer>
                    <strong>General documents required</strong>
                  </ControlContainer>
                </Section>
              </TD>
            </TR>
            {documents.filter((doc) => doc.displayCode !== REQUIRED_DOCUMENT_DISPLAY_CODE.OneDocRequiredPerBenefitExpense).map((document, idx) => (
              <TR key={idx}>
                <TD className="tooltip-container" style={{ border: 'none' }}>
                  {idx + 1}. {this.getTranslatedDescription(document, intl)}
                  {document.mandatory && <span style={{ color: 'red' }}> *</span>}
                  {document.mandatory && <span className="tooltip-text">{document.toolTipDescription}</span>}
                </TD>
                <TD className="text-left">
                  <div>
                    <ShowSupportingDocuments
                      claimCode={data.claimCode}
                      data={attachDocuments}
                      onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', '')}
                      onDelete={onFileRemove}
                      disabled={isReadOnly}
                      requiredDocumentId={document.claimRequiredDocumentId}
                      claimExpenseGuid={''}
                    />
                    <UploadSupportingDocuments
                      claimCode={data.claimCode}
                      data={attachDocuments}
                      onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', '')}
                      onDelete={onFileRemove}
                      disabled={isReadOnly}
                    />
                  </div>
                </TD>
                <TD style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
                  {showReviewColumn && (
                    <ShowPBValidationMesssage
                      document={document}
                      attachDocuments={attachDocuments}
                      hasPendingDocAnywhere={hasPendingDocAnywhere}
                      onRunValidation={this.onRunValidation}
                      isReadOnly={isReadOnly}
                      data={data}
                      onCancelValidation={this.onCancelValidation}
                    />
                  )}
                </TD>
              </TR>
            ))}
            {expenses.map((expense, expenseIdx) => [
              <TR
                key={`expense-header-${expenseIdx}`}
                className="no-hover"
                style={{ pointerEvents: 'none' }}
              >
                <TD colSpan={showReviewColumn ? 3 : 3} style={{ border: 'none' }}>
                  <Section>
                    <ControlContainer>
                      <strong>Documents for Expense {expenseIdx + 1}:</strong>
                      <br />
                      Name of organization: {expense.shortDescription}
                      <br />
                      Description of expense: {expense.shortDescription}
                      <br />
                      Amount claimed: {expense.currency} {expense.clientCost}
                      <br />
                      Reimbursement received: {expense.reimbursementReceived}
                    </ControlContainer>
                  </Section>
                </TD>
              </TR>,
              documents.filter((doc) => doc.displayCode === REQUIRED_DOCUMENT_DISPLAY_CODE.OneDocRequiredPerBenefitExpense).map((document, idx) => (
                <TR key={`expense-${expenseIdx}-doc-${idx}`}>
                  <TD className="tooltip-container" style={{ border: 'none' }}>
                    {idx + 1}. {this.getTranslatedDescription(document, intl)}
                    {document.mandatory && <span style={{ color: 'red' }}> *</span>}
                    {document.mandatory && <span className="tooltip-text">{document.toolTipDescription}</span>}
                  </TD>
                  <TD className="text-left">
                    <div>
                      <ShowSupportingDocuments
                        claimCode={data.claimCode}
                        data={attachDocuments}
                        onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, expense.claimExpenseGuid, document.displayCode)}
                        onDelete={onFileRemove}
                        disabled={isReadOnly}
                        requiredDocumentId={document.claimRequiredDocumentId}
                        claimExpenseGuid={expense.claimExpenseGuid}
                      />
                      <UploadSupportingDocuments
                        claimCode={data.claimCode}
                        data={attachDocuments}
                        onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, expense.claimExpenseGuid, document.displayCode)}
                        onDelete={onFileRemove}
                        disabled={isReadOnly}
                      />
                    </div>
                  </TD>
                  <TD style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
                    {showReviewColumn && (
                      <ShowPBEValidationMesssage
                        document={document}
                        attachDocuments={attachDocuments}
                        expense={expense}
                        hasPendingDocAnywhere={hasPendingDocAnywhere}
                        onRunValidation={this.onRunValidation}
                        onCancelValidation={this.onCancelValidation}
                        isReadOnly={isReadOnly}
                        data={data}
                      />
                    )}
                  </TD>
                </TR>
              ))
            ]).flat()}
          </tbody>
        }
        {!isExpenseLevelVersion &&
          <tbody>
            {documents.map((document, idx) => (
              <TR key={idx}>
                <TD className="tooltip-container" style={{ border: 'none' }}>
                  {idx + 1}. {this.getTranslatedDescription(document, intl)}
                  {document.mandatory && <span style={{ color: 'red' }}> *</span>}
                  {document.mandatory && <span className="tooltip-text">{document.toolTipDescription}</span>}
                </TD>
                <TD className="text-left">
                  <div>
                    <ShowSupportingDocuments
                      claimCode={data.claimCode}
                      data={attachDocuments}
                      onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', '')}
                      onDelete={onFileRemove}
                      disabled={isReadOnly}
                      requiredDocumentId={document.claimRequiredDocumentId}
                      claimExpenseGuid={''}
                    />
                    <UploadSupportingDocuments
                      claimCode={data.claimCode}
                      data={attachDocuments}
                      onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', '')}
                      onDelete={onFileRemove}
                      disabled={isReadOnly}
                    />
                  </div>
                </TD>
                <TD style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
                  {showReviewColumn && (
                    <ShowPBValidationMesssage
                      document={document}
                      attachDocuments={attachDocuments}
                      hasPendingDocAnywhere={hasPendingDocAnywhere}
                      onRunValidation={this.onRunValidation}
                      isReadOnly={isReadOnly}
                      data={data}
                      onCancelValidation={this.onCancelValidation}
                    />
                  )}
                </TD>
              </TR>
            ))}
          </tbody>
        }
      </Table >
    </div>
  );

  renderSCTIRequireDocMessage = (documents, data, expenses, showReviewColumn, hasPendingDocAnywhere, attachDocuments, isReadOnly, onAttachRequiredDocumentChange, onFileRemove, intl) => (
    <div>
      <Table style={{ tableLayout: 'fixed', width: '100%' }}>
        <thead>
          <TR>
            <TH className="document-table-top document-table-left document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: '50%' }}>
              <FormattedMessage {...messages.DocDocument} id={messages.DocDocument.id} />
            </TH>
            <TH className="document-table-top document-table-left align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: showReviewColumn ? '25%' : '50%' }}>
              <FormattedMessage {...messages.DocUploaded} id={messages.DocUploaded.id} />
            </TH>
            <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'} style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
              {showReviewColumn && (
                <FormattedMessage {...messages.InitialDocumentReview} id={messages.InitialDocumentReview.id} />
              )}
            </TH>
          </TR>
        </thead>
        <tbody>
          {documents.map((document, idx) => (
            <TR key={idx}>
              <TD className="tooltip-container" style={{ border: 'none' }}>
                {idx + 1}. {this.getTranslatedDescription(document, intl)}
                {document.mandatory && <span style={{ color: 'red' }}> *</span>}
                {document.mandatory && <span className="tooltip-text">{document.toolTipDescription}</span>}
              </TD>
              <TD className="text-left">
                <div>
                  <ShowSupportingDocuments
                    claimCode={data.claimCode}
                    data={attachDocuments}
                    onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', '')}
                    onDelete={onFileRemove}
                    disabled={isReadOnly}
                    requiredDocumentId={document.claimRequiredDocumentId}
                  />
                  <UploadSupportingDocuments
                    claimCode={data.claimCode}
                    data={attachDocuments}
                    onChange={onAttachRequiredDocumentChange.bind(this, data.claimCode, document.claimRequiredDocumentId, data.claimTypeId, '', '')}
                    onDelete={onFileRemove}
                    disabled={isReadOnly}
                  />
                </div>
              </TD>
              <TD style={{ width: '25%', minWidth: '200px', display: showReviewColumn ? 'table-cell' : 'none' }}>
                {showReviewColumn && (() => {
                  const hasRunValidation = document.Success === true || document.Success === false;
                  const hasPendingDoc = document.Success === null;

                  const documentSuccess = document.Success;
                  const documentMessage = document.Message;

                  const tooltipContent = "We've detected potential issues with your selected document.\nIf you believe this is an error, you can still proceed with submitting your claim.";

                  // Check if this specific document has any attachments uploaded
                  const hasAttachmentForThisDocument = attachDocuments.some(
                    attachment => attachment.requiredDocumentId === document.claimRequiredDocumentId
                  );

                  return (
                    <div>
                      {hasPendingDoc ? (
                        <div>
                          <div
                            style={{
                              backgroundColor: '#FFF9C4',
                              padding: '10px',
                              borderRadius: '6px',
                              display: 'flex',
                              alignItems: 'center',
                              color: '#bfa100'
                            }}
                          >
                            <span
                              style={{
                                color: '#bfa100',
                                marginRight: '8px',
                                fontSize: '16px',
                              }}
                            >
                              ⌛
                            </span>
                            <span>Validating...</span>

                          </div>
                          <button
                            className="btn btn-sm btn-primary mt-2"
                            onClick={() => this.onCancelValidation(document.claimRequiredDocumentId, data.claimTypeId)}
                          >
                            Cancel Validation
                          </button>
                        </div>
                      ) : documentSuccess === true ? (
                        <div
                          style={{
                            backgroundColor: '#DDFFDD',
                            padding: '10px',
                            borderRadius: '6px',
                            position: 'relative',
                            color: '#2e7d32',
                          }}
                        >
                          <div>
                            <span
                              style={{
                                color: '#4CAF50',
                                marginRight: '8px',
                                fontSize: '18px',
                                fontWeight: 'bold',
                              }}
                            >
                              ✓
                            </span>
                            <span>
                              {documentMessage || 'Document accepted.'}
                            </span>
                          </div>
                        </div>
                      ) : documentSuccess === false && documentMessage && hasAttachmentForThisDocument ? (
                        <div
                          style={{
                            backgroundColor: '#FFDDDD',
                            padding: '10px',
                            borderRadius: '6px',
                            color: '#c62828',
                            position: 'relative',
                            paddingRight: '30px',
                            marginBottom: '8px',
                          }}
                        >
                          <span
                            style={{
                              position: 'absolute',
                              top: '8px',
                              right: '8px',
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              backgroundColor: '#1976d2',
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            title={tooltipContent.replace('\n', '\r\n')}
                            data-toggle="tooltip"
                            data-html="true"
                            data-placement="top"
                          >
                            i
                          </span>

                          {documentMessage.split(/<br\s*\/?>/gi).map((line, lineIndex) => (
                            line.trim() && (
                              <div key={`line-${lineIndex}`}>
                                <span
                                  style={{
                                    color: '#F44336',
                                    marginRight: '8px',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  ✕
                                </span>
                                <span>
                                  {line.trim()}
                                </span>
                              </div>
                            )
                          ))}
                        </div>
                      ) : (() => {
                        // Only show "Document accepted" if document has attachment and runDocumentValidation is false
                        return document.runDocumentValidation === false && hasAttachmentForThisDocument ? (
                          <div
                            style={{
                              backgroundColor: '#DDFFDD',
                              padding: '10px',
                              borderRadius: '6px',
                              position: 'relative',
                              color: '#2e7d32',
                            }}
                          >
                            <div>
                              <span
                                style={{
                                  color: '#4CAF50',
                                  marginRight: '8px',
                                  fontSize: '18px',
                                  fontWeight: 'bold',
                                }}
                              >
                                ✓
                              </span>
                              <span>Document accepted.</span>
                            </div>
                          </div>
                        ) : null;
                      })()}

                      {(() => {
                        if (!hasPendingDocAnywhere && document.runDocumentValidation !== false && hasAttachmentForThisDocument) {
                          return (
                            <div className="row align-items-center justify-content-center">
                              <div className="col-auto">
                                <button
                                  className="btn btn-sm btn-primary mt-2"
                                  onClick={() => this.onRunValidation([], document.claimRequiredDocumentId, data.claimTypeId)}
                                  disabled={isReadOnly}
                                >
                                  {hasRunValidation ? 'Check Again' : 'Check My Documents'}
                                </button>
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })()}
                    </div>
                  );
                })()}
              </TD>
            </TR>
          ))}
        </tbody>
      </Table>
    </div>
  );

  renderSCTIWarningMessage = (isReadOnly, warningMissingRequiredDocument) => (
    <div>
      <P>
        <FormattedMessage {...messages.youHaveNotAttachedAnyRequiredDocumentsForYourClaimSCTI} />
      </P>
      <P>
        <FormattedMessage {...messages.warningMissingRequiredDocumentDetailsSCTI} />
      </P>
      <P>
        <FormattedMessage {...messages.youMayAlsoSaveThisClaimAsADraftAndReturnAnytimeWithin30DaysOfCommencementToAttachTheRequiredDocumentsSCTI} />
      </P>
      <div className="row">
        <div className="form-group col-md-12">
          <FlexBox>
            <OptionsContainer>
              <FormattedMessage {...messages.wouldYouLikeToProceedToNextStepsSCTI} />
            </OptionsContainer>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                value="true"
                checked={warningMissingRequiredDocument === 'true'}
                onChange={this.handleChange('form.warningMissingRequiredDocument')}
              />
              <FormattedMessage {...messages.yes} />
            </OptionsContainer>
            <OptionsContainer>
              <input
                disabled={isReadOnly}
                type="radio"
                value="false"
                checked={warningMissingRequiredDocument === 'false'}
                onChange={this.handleChange('form.warningMissingRequiredDocument')}
              />
              <FormattedMessage {...messages.no} />
            </OptionsContainer>
          </FlexBox>
        </div>
      </div>
    </div>
  );

  renderInstructions() {
    return (
      <div className="col-md-12 pt-3 px-3">
        <i>Kindly follow instructions carefully:</i>
        <ul className="mt-2">
          <li>For each <b>Document</b> section in the table below, provide relevant supporting documents. Ensure the documents are easy to read and the details match the claim as clearly as possible.</li>
          <li>If necessary, you can attach more than one document per <b>Document</b> row. For example, if your itinerary consists of 3 pages and they have been individually scanned or photographed, attach all 3 in the same <b>Document</b> row.</li>
          <li>If you receive a red warning block but believe the validation misunderstood or missed something, please ignore the warning and proceed with your claim.</li>
          <li>If you need to update claim details on a different screen or upload a different document, click the blue <b>Check Again</b> button to check for remaining warnings.</li>
        </ul>
      </div>
    );
  }

  renderStandardWarningMessage = (showWarningMissingRequiredDocument, showWarningInvalidRequiredDocument, isReadOnly, warningMissingRequiredDocument) => {
    return (
      <div>
        <Section>
          <ControlContainer>
            {showWarningMissingRequiredDocument && (
              <div>
                <h5 style={{ fontWeight: 'bold', color: 'red' }}>
                  <FormattedMessage {...messages.warningMissingRequiredDocument} />
                </h5>
                <P>
                  <FormattedMessage {...messages.warningMissingRequiredDocumentText1} />
                </P>
              </div>
            )}

            {showWarningInvalidRequiredDocument && (
              <div>
                <h5 style={{ fontWeight: 'bold', color: 'red' }}>
                  <FormattedMessage {...messages.warningInvalidRequiredDocument} />
                </h5>
                <P>
                  <FormattedMessage {...messages.warningInvalidRequiredDocumentText1} />
                </P>
              </div>
            )}

            <div className={'row'}>
              <div className={'form-group col-md-12'}>
                <FlexBox>
                  <OptionsContainer>
                    <FormattedMessage {...messages.wouldYouLikeToProceedToNextSteps} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={warningMissingRequiredDocument === 'true'}
                      onChange={this.handleChange('form.warningMissingRequiredDocument')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={warningMissingRequiredDocument === 'false'}
                      onChange={this.handleChange('form.warningMissingRequiredDocument')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
          </ControlContainer>
        </Section>
      </div>
    );
  }

  renderWarningMissingRequiredDocument = (showWarningMissingRequiredDocument, showWarningInvalidRequiredDocument, warningMissingRequiredDocument, isReadOnly) => {
    const isScti = appConfig.reactAppEnv === 'scti';
    return (
      <div>
        <Section>
          <ControlContainer>
            <h5 style={{ fontWeight: 'bold', color: 'red' }}>
              <FormattedMessage {...messages.warningMissingRequiredDocument} />
            </h5>
            {isScti
              ? this.renderSCTIWarningMessage(isReadOnly, warningMissingRequiredDocument)
              : this.renderStandardWarningMessage(showWarningMissingRequiredDocument, showWarningInvalidRequiredDocument, isReadOnly, warningMissingRequiredDocument)
            }
          </ControlContainer>
        </Section>
      </div>
    );
  };

  onCancelValidation(requiredDocumentId, claimTypeId) {
    const { onCancelRequiredDocValidation } = this.props;
    onCancelRequiredDocValidation(requiredDocumentId, claimTypeId);
  }

  render() {
    const {
      attachDocuments,
      uploadPercentage,
      progressBarVisibility,
      showWarningMissingRequiredDocument,
      showWarningInvalidRequiredDocument,
      warningMissingRequiredDocument,
    } = this.props.form;
    const { isSummary, submitted, loading, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    const isNextStep = (!showWarningMissingRequiredDocument && !showWarningInvalidRequiredDocument) ? true : warningMissingRequiredDocument === 'true';
    const { invalidFileName, isLongFileName, listDocuments } = this.state;
    const effectiveHasFormChanges = this.props.hasFormChanges && !progressBarVisibility;
    return (
      <div className="app-content">

        <Section className="text-center">
          <P className="mb-0 normal-text"><FormattedMessage {...messages.provideAll} id={messages.provideAll.id} /></P>
        </Section>
        <Section>
          <ProgressBar
            percent={uploadPercentage}
            style={{ display: progressBarVisibility ? '' : 'none' }}
            trailColor="#D9D9D9"
            strokeColor="#2db7f5"
          />
        </Section>
        {this.renderUploadAreaForBenefits(listDocuments, attachDocuments, this.onAttachDocumentChange, this.onAttachRequiredDocumentChange, this.handleFileRemove, isReadOnly)}
        {(showWarningMissingRequiredDocument || showWarningInvalidRequiredDocument) && this.renderWarningMissingRequiredDocument(showWarningMissingRequiredDocument, showWarningInvalidRequiredDocument, warningMissingRequiredDocument, isReadOnly)}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className={`${appConfig.reactAppEnv === 'scti' ? 'base-button back-button' : 'btn-outline'}`}
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.back' })}
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.save' })}
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
        <ModalError isLongFileName={isLongFileName} isOpen={invalidFileName} onClose={this.hideModal} />
      </div>
    );
  }
}
StepSupportingDocuments.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFileUpload: PropTypes.func,
  onFileRemove: PropTypes.func,
  onRequireDocFileUpload: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  onFormDataSave: PropTypes.func,
  stepWhatHappenedData: PropTypes.any,
  stepTripCancellationAndTripInterruptionData: PropTypes.any,
  stepOtherData: PropTypes.any,
  stepTripCancellationCFData: PropTypes.any,
  stepTravelDelayData: PropTypes.any,
  stepTripDelayData: PropTypes.any,
  stepMedicalAndEvacuationSCTIData: PropTypes.any,
  stepBaggageAndPersonalItemsSCTIData: PropTypes.any,
  stepChangesToYourJourneySCTIData: PropTypes.any,
  stepChangesToYourJourneyData: PropTypes.any,
  stepBaggageAndPersonalItemsData: PropTypes.any,
  stepBaggageAndPersonalItemsStarrData: PropTypes.any,
  stepMedicalExpenseCFData: PropTypes.any,
  stepOtherStarrData: PropTypes.any,
  stepCollisionDamageStarrData: PropTypes.any,
  stepCollisionDamageData: PropTypes.any,
  stepCashBankCardsTravelDocumentsAndPassportsData: PropTypes.any,
  stepMedicalExpensesTugoData: PropTypes.any,
  stepOtherTugoData: PropTypes.any,
  stepMedicalExpenseCFData: PropTypes.any,
  stepBaseVictorsMedicalTugoData: PropTypes.any,
  claimTypesInit: PropTypes.any,
  jsonVersion: PropTypes.string,
  showRequiredDocument: PropTypes.bool,
  policyTypeCode: PropTypes.string,
  showZurichUHC: PropTypes.bool,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  intl: intlShape.isRequired,
  onRunRequiredDocValidation: PropTypes.func,
  onCancelRequiredDocValidation: PropTypes.func,
  hasFormChanges: PropTypes.bool,
  setFormHasChanges: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepSupportingDocuments(),
  loading: makeSelectProgressBarStatus(),
  stepWhatHappenedData: makeSelectStepWhatHappened(),
  stepTripCancellationAndTripInterruptionData: makeSelectStepTripCancellationAndTripInterruption(),
  stepOtherData: makeSelectStepOther(),
  stepTripCancellationCFData: makeSelectTripCancellationCFStep(),
  stepTravelDelayData: makeSelectStepTravelDelay(),
  stepTripDelayData: makeSelectTripDelayStep(),
  stepMedicalAndEvacuationSCTIData: makeSelectMedicalAndEvacuationSCTIStep(),
  stepBaggageAndPersonalItemsSCTIData: makeSelectBaggageAndPersonalItemsSCTIStep(),
  stepChangesToYourJourneySCTIData: makeSelectChangesToYourJourneySCTIStep(),
  stepChangesToYourJourneyData: makeSelectChangesToYourJourneyStep(),
  stepBaggageAndPersonalItemsData: makeSelectStepBaggageAndPersonalItems(),
  stepMedicalExpenseCFData: makeSelectMedicalExpenseCFStep(),
  stepBaggageAndPersonalItemsStarrData: makeSelectStepBaggageAndPersonalItemsStarr(),
  stepOtherStarrData: makeSelectStepOtherStarr(),
  stepCollisionDamageStarrData: makeSelectCollisionDamageStarrStep(),
  stepCollisionDamageData: makeSelectCollisionDamageStep(),
  stepCashBankCardsTravelDocumentsAndPassportsData: makeSelectCashBankCardsTravelDocumentsAndPassportsStep(),
  stepMedicalExpensesTugoData: makeSelectMedicalExpensesTugoStep(),
  stepOtherTugoData: makeSelectStepOtherTugo(),
  // stepMedicalExpenseCFData: makeSelectMedicalExpenseCFStep(),
  stepBaseVictorsMedicalTugoData: makeSelectBaseVictorsMedicalTugo(),
  claimTypesInit: makeSelectInitClaimTypeList(),
  jsonVersion: makeSelectJSONVersion(),
  showRequiredDocument: makeSelectShowRequiredDocument(),
  policyTypeCode: makeSelectPolicyTypeCode(),
  showZurichUHC: makeSelectShowZurichUHC(),
  errors: makeSelectStepSupportingDocumentsErrors(),
  currentStep: makeSelectCurrentStep(),
  hasFormChanges: makeSelectFormHasChanges(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFileUpload: (files, benefitCode) => dispatch(uploadFile(files, benefitCode)),
  onRequireDocFileUpload: (files, uploadRequest) => dispatch(uploadRequireDocFile(files, uploadRequest)),
  onFileRemove: (file) => dispatch(removeFile(file)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onReset: () => {
    dispatch(resetFormData());
  },
  onRunRequiredDocValidation: (attachmentIds, requiredDocumentId, claimTypeId) =>
    dispatch(runRequiredDocValidation(attachmentIds, requiredDocumentId, claimTypeId)),
  onCancelRequiredDocValidation: (requiredDocumentId, claimTypeId) =>
    dispatch(cancelRequiredDocValidation(requiredDocumentId, claimTypeId)),
  setFormHasChanges: (hasFormChanges) => dispatch(setFormHasChanges(hasFormChanges)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepSupportingDocuments', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl
)(StepSupportingDocuments);


// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/index.js